import { DateField as DateField$1, LocalizationProvider as LocalizationProvider$1 } from '@mui/x-date-pickers';
import { AdapterDateFns as AdapterDateFns$1 } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker as DatePicker$1, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import React, { forwardRef, useState, useCallback, useMemo, useRef, useEffect, useLayoutEffect, Children, isValidElement, cloneElement } from 'react';
import { Warning, CheckCircleRounded, VisibilityRounded, ExpandMoreRounded } from '@mui/icons-material';
import { styled, Alert as Alert$1, AlertTitle, Typography as Typography$1, Collapse, IconButton, Button as Button$1, Tooltip as Tooltip$1, InputAdornment, TextField as TextField$1, Autocomplete as Autocomplete$1, Box, FormHelperText, FormControlLabel, FormControl, Checkbox as Checkbox$1, Radio as Radio$1, Accordion as Accordion$1, AccordionSummary as AccordionSummary$1, AccordionDetails, keyframes, Select as Select$1, MenuItem, ListItemText, Divider as Divider$2, OutlinedInput, InputLabel, Paper, SvgIcon, Drawer, Unstable_TrapFocus, RadioGroup, SnackbarContent, Snackbar as Snackbar$1, StepConnector, stepConnectorClasses, Step, Stepper as Stepper$1, StepLabel, ToggleButtonGroup, ToggleButton as ToggleButton$1, AccordionActions, DialogContent, DialogTitle, Dialog, useMediaQuery } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { styled as styled$1, useTheme, shouldForwardProp } from '@chargeafter/theme';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ReplyIcon from '@mui/icons-material/Reply';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import ReplyRoundedIcon from '@mui/icons-material/ReplyRounded';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ReactInputMask from 'react-input-mask';
import { useIntl, FormattedMessage, FormattedNumber } from 'react-intl';
import { parse } from 'date-fns';
import NumberFormat from 'react-number-format';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CategoryIcon from '@mui/icons-material/Category';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DraftsIcon from '@mui/icons-material/Drafts';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PaymentsIcon from '@mui/icons-material/Payments';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import isEqual from 'lodash/isEqual';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import MuiSwitch from '@mui/material/Switch';
import ArrowBack from '@mui/icons-material/ArrowBackIosNew';
import { useIMask } from 'react-imask';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$l =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$m = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$l = fails$m;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$l(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$k = fails$m;

var functionBindNative = !fails$k(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$j = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$j.bind(call$j) : function () {
  return call$j.apply(call$j, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$i = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$i, call$i);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$i.apply(fn, arguments);
  };
};

var uncurryThis$o = functionUncurryThis;

var toString$9 = uncurryThis$o({}.toString);
var stringSlice$8 = uncurryThis$o(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$8(toString$9(it), 8, -1);
};

var uncurryThis$n = functionUncurryThis;
var fails$j = fails$m;
var classof$8 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$n(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$j(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$6 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$5 = isNullOrUndefined$6;

var $TypeError$g = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (isNullOrUndefined$5(it)) throw $TypeError$g("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$5(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$p = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$o = isCallable$p;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$a = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$o(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$o(it);
};

var global$k = global$l;
var isCallable$n = isCallable$p;

var aFunction = function (argument) {
  return isCallable$n(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$k[namespace]) : global$k[namespace] && global$k[namespace][method];
};

var uncurryThis$m = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$m({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$j = global$l;
var userAgent$3 = engineUserAgent;

var process$4 = global$j.process;
var Deno$1 = global$j.Deno;
var versions = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$i = fails$m;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$i(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$m = isCallable$p;
var isPrototypeOf$5 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$m($Symbol) && isPrototypeOf$5($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$l = isCallable$p;
var tryToString$3 = tryToString$4;

var $TypeError$f = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$9 = function (argument) {
  if (isCallable$l(argument)) return argument;
  throw $TypeError$f(tryToString$3(argument) + ' is not a function');
};

var aCallable$8 = aCallable$9;
var isNullOrUndefined$4 = isNullOrUndefined$6;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$5 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$4(func) ? undefined : aCallable$8(func);
};

var call$h = functionCall;
var isCallable$k = isCallable$p;
var isObject$9 = isObject$a;

var $TypeError$e = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$k(fn = input.toString) && !isObject$9(val = call$h(fn, input))) return val;
  if (isCallable$k(fn = input.valueOf) && !isObject$9(val = call$h(fn, input))) return val;
  if (pref !== 'string' && isCallable$k(fn = input.toString) && !isObject$9(val = call$h(fn, input))) return val;
  throw $TypeError$e("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$i = global$l;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$i, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$i[key] = value;
  } return value;
};

var global$h = global$l;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$h[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.28.0',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$4 = requireObjectCoercible$6;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$2(requireObjectCoercible$4(argument));
};

var uncurryThis$l = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$l({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$k = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$8 = uncurryThis$k(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$8(++id + postfix, 36);
};

var global$g = global$l;
var shared$3 = shared$4.exports;
var hasOwn$c = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$g.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$k = function (name) {
  if (!hasOwn$c(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$c(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$g = functionCall;
var isObject$8 = isObject$a;
var isSymbol$1 = isSymbol$2;
var getMethod$4 = getMethod$5;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$j = wellKnownSymbol$k;

var $TypeError$d = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$j('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$8(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$4(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$g(exoticToPrim, input, pref);
    if (!isObject$8(result) || isSymbol$1(result)) return result;
    throw $TypeError$d("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$f = global$l;
var isObject$7 = isObject$a;

var document$3 = global$f.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$7(document$3) && isObject$7(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$c = descriptors;
var fails$h = fails$m;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$c && !fails$h(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$b = descriptors;
var call$f = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$b = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$b ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$b(O, P)) return createPropertyDescriptor$2(!call$f(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$a = descriptors;
var fails$g = fails$m;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$a && fails$g(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$6 = isObject$a;

var $String$3 = String;
var $TypeError$c = TypeError;

// `Assert: Type(argument) is Object`
var anObject$e = function (argument) {
  if (isObject$6(argument)) return argument;
  throw $TypeError$c($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$9 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$d = anObject$e;
var toPropertyKey = toPropertyKey$2;

var $TypeError$b = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$9 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$d(O);
  P = toPropertyKey(P);
  anObject$d(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$d(O);
  P = toPropertyKey(P);
  anObject$d(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$b('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$8 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$6 = DESCRIPTORS$8 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$7 = descriptors;
var hasOwn$a = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$7 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$a(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$7 || (DESCRIPTORS$7 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$j = functionUncurryThis;
var isCallable$j = isCallable$p;
var store$1 = sharedStore;

var functionToString = uncurryThis$j(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$j(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$e = global$l;
var isCallable$i = isCallable$p;

var WeakMap$1 = global$e.WeakMap;

var weakMapBasicDetection = isCallable$i(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$d = global$l;
var isObject$5 = isObject$a;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
var hasOwn$9 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$d.TypeError;
var WeakMap = global$d.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$5(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$9(it, STATE)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$9(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$9(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$i = functionUncurryThis;
var fails$f = fails$m;
var isCallable$h = isCallable$p;
var hasOwn$8 = hasOwnProperty_1;
var DESCRIPTORS$6 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState$1 = InternalStateModule$2.enforce;
var getInternalState$2 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;
var stringSlice$7 = uncurryThis$i(''.slice);
var replace$4 = uncurryThis$i(''.replace);
var join = uncurryThis$i([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$6 && !fails$f(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$7($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$4($String$2(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$8(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$6) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$8(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$8(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$6) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$1(value);
  if (!hasOwn$8(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$h(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$g = isCallable$p;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$8 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$g(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$2 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$2(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$3 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$2(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$h = functionUncurryThis;
var hasOwn$7 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$2 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$h([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$7(hiddenKeys$2, key) && hasOwn$7(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$7(O, key = names[i++])) {
    ~indexOf$2(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$7;
var uncurryThis$g = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$c = anObject$e;

var concat$2 = uncurryThis$g([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$c(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$6 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$6(target, key) && !(exceptions && hasOwn$6(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$e = fails$m;
var isCallable$f = isCallable$p;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$f(detection) ? fails$e(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var global$c = global$l;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var defineBuiltIn$7 = defineBuiltIn$8;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$2 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$c;
  } else if (STATIC) {
    target = global$c[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$c[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    defineBuiltIn$7(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$5 = descriptors;
var uncurryThis$f = functionUncurryThis;
var call$e = functionCall;
var fails$d = fails$m;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$3 = toObject$5;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$5 = Object.defineProperty;
var concat$1 = uncurryThis$f([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$d(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$5 && $assign({ b: 1 }, $assign(defineProperty$5({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$5(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$5 || call$e(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$e = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$e({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var wellKnownSymbol$i = wellKnownSymbol$k;

var TO_STRING_TAG$3 = wellKnownSymbol$i('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$e = isCallable$p;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$h = wellKnownSymbol$k;

var TO_STRING_TAG$2 = wellKnownSymbol$h('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) == 'Object' && isCallable$e(O.callee) ? 'Arguments' : result;
};

var classof$6 = classof$7;

var $String$1 = String;

var toString$7 = function (argument) {
  if (classof$6(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$4 = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$4.f(target, name, descriptor);
};

var $$d = _export;
var DESCRIPTORS$4 = descriptors;
var global$b = global$l;
var uncurryThis$e = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var isCallable$d = isCallable$p;
var isPrototypeOf$4 = objectIsPrototypeOf;
var toString$6 = toString$7;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$b.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$4 && isCallable$d(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$6(arguments[0]);
    var result = isPrototypeOf$4(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis$e(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$e(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$3 = uncurryThis$e(''.replace);
  var stringSlice$6 = uncurryThis$e(''.slice);

  defineBuiltInAccessor$1(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$5(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$6(string, 7, -1) : replace$3(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$d({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const List = styled('ul')(({
  theme
}) => Object.assign({}, theme.typography.body2, {
  paddingLeft: theme.spacing(3),
  '*[dir="rtl"] &': {
    paddingLeft: 'initial',
    paddingRight: theme.spacing(3)
  },
  color: 'inherit'
}));
const ListItem = styled('li')(() => ({}));
const Alert = ({
  severity,
  title,
  title2,
  description,
  list
}) => {
  return /*#__PURE__*/jsxs(Alert$1, {
    "data-test-id": "alert",
    iconMapping: {
      error: /*#__PURE__*/jsx(Warning, {
        fontSize: "inherit"
      }),
      success: /*#__PURE__*/jsx(CheckCircleRounded, {
        fontSize: "inherit"
      }),
      warning: /*#__PURE__*/jsx(Warning, {
        fontSize: "inherit"
      })
    },
    severity: severity,
    children: [/*#__PURE__*/jsx(AlertTitle, {
      "data-test-id": "alert-title",
      children: title
    }), title2 && /*#__PURE__*/jsx(AlertTitle, {
      children: title2
    }), description, list && /*#__PURE__*/jsx(List, {
      children: list.map((item, index) => /*#__PURE__*/jsx(ListItem, {
        children: item
      }, index))
    })]
  });
};

var objectDefineProperties = {};

var DESCRIPTORS$3 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$b = anObject$e;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$3 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$b(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$a = anObject$e;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$a(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$g = wellKnownSymbol$k;
var create$2 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$g('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$c = fails$m;

var correctPrototypeGetter = !fails$c(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$4 = hasOwnProperty_1;
var isCallable$c = isCallable$p;
var toObject$2 = toObject$5;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$2(O);
  if (hasOwn$4(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$c(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$b = fails$m;
var isCallable$b = isCallable$p;
var isObject$4 = isObject$a;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$6 = defineBuiltIn$8;
var wellKnownSymbol$f = wellKnownSymbol$k;

var ITERATOR$5 = wellKnownSymbol$f('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$4(IteratorPrototype$2) || fails$b(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$b(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn$6(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$3 = hasOwnProperty_1;
var wellKnownSymbol$e = wellKnownSymbol$k;

var TO_STRING_TAG$1 = wellKnownSymbol$e('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$3(target, TO_STRING_TAG$1)) {
    defineProperty$2(target, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$d = functionUncurryThis;
var aCallable$7 = aCallable$9;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$d(aCallable$7(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isCallable$a = isCallable$p;

var $String = String;
var $TypeError$a = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$a(argument)) return argument;
  throw $TypeError$a("Can't set " + $String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$9 = anObject$e;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$9(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$c = _export;
var call$d = functionCall;
var FunctionName = functionName;
var isCallable$9 = isCallable$p;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;
var defineBuiltIn$5 = defineBuiltIn$8;
var wellKnownSymbol$d = wellKnownSymbol$k;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$d('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$2) {
          setPrototypeOf$2(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$9(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$5(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$3(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$d(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$5(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$c({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$5(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$2 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$2 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$a = global$l;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var wellKnownSymbol$c = wellKnownSymbol$k;

var ITERATOR$3 = wellKnownSymbol$c('iterator');
var TO_STRING_TAG = wellKnownSymbol$c('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty$2(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty$2(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$2(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$a[COLLECTION_NAME] && global$a[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var classof$5 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof$5(argument) == 'Array';
};

var $$b = _export;
var uncurryThis$c = functionUncurryThis;
var isArray = isArray$1;

var nativeReverse = uncurryThis$c([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$$b({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

const ErrorContainer = styled$1('span')({
  position: 'relative',
  display: 'inline-block'
});
const ErrorText = ({
  helperText
}) => {
  const errors = Array.isArray(helperText) ? helperText : [helperText];
  return /*#__PURE__*/jsxs(ErrorContainer, {
    children: [/*#__PURE__*/jsx(CancelRoundedIcon, {
      sx: {
        position: 'absolute',
        left: -14,
        top: 3,
        width: 12,
        height: 12
      }
    }), errors.map(error => /*#__PURE__*/jsx("div", {
      role: "alert",
      children: error
    }, error))]
  });
};

const StyledBlockquote = styled('div')(({
  theme,
  spacing
}) => {
  const {
    top = 2,
    left = 2,
    right = 2,
    bottom = 2
  } = spacing || {};
  return {
    boxSizing: 'border-box',
    padding: theme.spacing(top, right, bottom, left),
    borderLeft: `2px solid ${theme.palette.grey[200]}`,
    color: theme.palette.grey[400]
  };
});
const Blockquote = ({
  children,
  spacing: _spacing = 2
}) => {
  const styledSpacing = typeof _spacing !== 'number' ? _spacing : {
    top: _spacing,
    bottom: _spacing
  };
  return /*#__PURE__*/jsx(StyledBlockquote, {
    "data-test-id": "blockquote",
    spacing: styledSpacing,
    children: children
  });
};

const _excluded$o = ["dataTestId"];
const StyledTypography$2 = styled$1(Typography$1, {
  shouldForwardProp: prop => prop !== 'upperCase'
})(({
  weight,
  upperCase
}) => Object.assign({}, weight && {
  fontWeight: weight
}, upperCase && {
  textTransform: 'uppercase'
}));
const Typography = _ref => {
  let {
      dataTestId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  return /*#__PURE__*/jsx(StyledTypography$2, Object.assign({
    "data-test-id": dataTestId != null ? dataTestId : 'typography'
  }, rest));
};

const TooltipWrapper = styled$1('div')(({
  theme
}) => ({
  marginTop: theme.spacing(2)
}));
const StyledCollapse = styled$1(Collapse)({
  margin: '-4px -14px 0px'
});
const InlineTooltip = ({
  tooltip,
  toggle
}) => {
  return /*#__PURE__*/jsx(StyledCollapse, {
    "data-test-id": "inline-tooltip",
    in: toggle,
    timeout: 500,
    children: /*#__PURE__*/jsx(TooltipWrapper, {
      children: /*#__PURE__*/jsx(Blockquote, {
        spacing: {
          top: 0,
          bottom: 0,
          right: 0
        },
        children: /*#__PURE__*/jsx(Typography, {
          variant: "legal",
          children: tooltip
        })
      })
    })
  });
};

const SearchIcon = () => {
  return /*#__PURE__*/jsx(IconButton, {
    "aria-label": "search text",
    children: /*#__PURE__*/jsxs("svg", {
      fill: "none",
      height: "14",
      viewBox: "0 0 14 14",
      width: "14",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("path", {
        d: "M6.41667 11.0833C8.994 11.0833 11.0833 8.994 11.0833 6.41667C11.0833 3.83934 8.994 1.75 6.41667 1.75C3.83934 1.75 1.75 3.83934 1.75 6.41667C1.75 8.994 3.83934 11.0833 6.41667 11.0833Z",
        stroke: "#65686D",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2"
      }), /*#__PURE__*/jsx("path", {
        d: "M12.2504 12.25L9.71289 9.71252",
        stroke: "#65686D",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2"
      })]
    })
  });
};

const _excluded$n = ["children", "icon", "variant"];
const variantMapping = {
  primary: 'contained',
  secondary: 'outlined',
  text: 'text',
  mini: 'contained',
  textWithIcon: 'textWithIcon',
  link: 'link',
  new: 'new'
};
const iconMap = {
  download: /*#__PURE__*/jsx(DownloadRoundedIcon, {}),
  eye: /*#__PURE__*/jsx(VisibilityRounded, {}),
  back: /*#__PURE__*/jsx(ArrowBackIosRoundedIcon, {}),
  export: /*#__PURE__*/jsx(ReplyRoundedIcon, {}),
  add: /*#__PURE__*/jsx(AddRoundedIcon, {}),
  edit: /*#__PURE__*/jsx(EditRoundedIcon, {}),
  lender: /*#__PURE__*/jsx(AccountBalanceOutlined, {}),
  merchant: /*#__PURE__*/jsx(StorefrontOutlinedIcon, {})
};
const Button = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      icon,
      variant = 'primary'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  return /*#__PURE__*/jsx(Button$1, Object.assign({
    ref: ref,
    "data-test-id": "button",
    "data-variant": variant,
    focusRipple: false
  }, Object.assign({
    variant: variantMapping[variant],
    fullWidth: variant !== 'mini' && !icon
  }, icon && {
    startIcon: iconMap[icon]
  }), rest, {
    children: children
  }));
});

const StyledInfoIcon = styled$1(InfoRoundedIcon)(({
  theme,
  tooltipHoverColor
}) => Object.assign({
  color: theme.palette.grey[400],
  fontSize: 'large',
  cursor: 'pointer'
}, tooltipHoverColor && {
  '&:hover': {
    color: theme.palette.primary[tooltipHoverColor]
  }
}));
const StyledIconButton = styled$1(IconButton)({
  '& *': {
    'pointer-events': 'none'
  }
});
const Tooltip = ({
  content,
  open,
  maxWidth: _maxWidth = 300,
  placement: _placement = 'top-end',
  tooltipHoverColor,
  inputName,
  tagName: _tagName = 'Tooltip',
  className
}) => {
  const [hideTooltip, setHideTooltip] = useState(false);
  const handleIconClick = e => {
    e.target.dispatchEvent(new CustomEvent('custom:iconclick', {
      bubbles: true,
      detail: {
        name: inputName,
        tag: _tagName
      }
    }));
  };
  function handleScroll() {
    setHideTooltip(true);
  }
  const onClose = useCallback(() => {
    document.removeEventListener('scroll', handleScroll, {
      capture: true
    });
  }, []);
  const onOpen = useCallback(() => {
    setHideTooltip(false);
    document.addEventListener('scroll', handleScroll, {
      capture: true
    });
  }, []);
  return /*#__PURE__*/jsx(Tooltip$1, {
    arrow: true,
    className: className,
    componentsProps: {
      tooltip: {
        sx: {
          maxWidth: _maxWidth
        }
      },
      popper: Object.assign({}, hideTooltip && {
        hidden: true
      })
    },
    "data-test-id": "tooltip",
    enterTouchDelay: 0,
    leaveTouchDelay: 500000,
    open: open,
    placement: _placement,
    title: content,
    onClose: onClose,
    onOpen: onOpen,
    children: /*#__PURE__*/jsx(StyledIconButton, {
      onClick: handleIconClick,
      children: /*#__PURE__*/jsx(StyledInfoIcon, {
        tooltipHoverColor: tooltipHoverColor
      })
    })
  });
};

const _excluded$m = ["fsMask", "error", "helperText", "displayAsValid", "icons", "endTooltip", "number", "innerLabel", "onChange", "inputComponent", "editButton", "disabled", "icon", "endTooltipProps", "onIconClick", "editButtonLabel", "inputProps", "InputProps", "tooltipVariant", "onFocus", "onBlur"];
const InnerLabel = styled$1('div')(({
  theme
}) => ({
  fontSize: '0.75rem',
  letterSpacing: '0.2px',
  lineHeight: '1rem',
  fontWeight: 400,
  color: theme.palette.primary.dark,
  backgroundColor: theme.palette.primary.lighter,
  padding: theme.spacing(0.5, 1),
  borderRadius: 6
}));
const StyledEditButton = styled$1(Button)(({
  theme
}) => ({
  padding: theme.spacing(1.125, 0.5, 1),
  textTransform: 'capitalize',
  minWidth: 'initial',
  '& .MuiButton-startIcon': {
    margin: theme.spacing(-0.25, 0.5, 0, 0),
    '& svg': {
      fontSize: '1.125rem'
    }
  }
}));
const StyledInputAdornment = styled$1(InputAdornment)(({
  theme
}) => ({
  '& button': {
    marginRight: theme.spacing(-1)
  }
}));
const fieldIcons = (theme, fieldName) => {
  const ariaLabelPrefix = fieldName ? ` for ${fieldName}` : '';
  const ariaLabelShortPrefix = fieldName ? ` ${fieldName}` : '';
  return {
    calendar: /*#__PURE__*/jsx(IconButton, {
      "aria-label": "pick a date",
      children: /*#__PURE__*/jsx(CalendarTodayRoundedIcon, {
        fontSize: 'small',
        sx: {
          color: theme.palette.grey[400]
        }
      })
    }),
    info: /*#__PURE__*/jsx(InfoRoundedIcon, {
      fontSize: 'small',
      sx: {
        color: theme.palette.grey[400]
      }
    }),
    visibility: /*#__PURE__*/jsx(IconButton, {
      "aria-label": `toggle vissible text${ariaLabelPrefix}`,
      children: /*#__PURE__*/jsx(VisibilityRoundedIcon, {
        sx: {
          color: theme.palette.grey[400]
        }
      })
    }),
    visibilityHidden: /*#__PURE__*/jsx(IconButton, {
      "aria-label": `toggle hide text${ariaLabelPrefix}`,
      children: /*#__PURE__*/jsx(VisibilityOffIcon, {
        sx: {
          color: theme.palette.grey[400]
        }
      })
    }),
    checkmark: /*#__PURE__*/jsx(CheckRoundedIcon, {
      fontSize: 'small',
      color: 'success'
    }),
    share: /*#__PURE__*/jsx(IconButton, {
      "aria-label": `share${ariaLabelShortPrefix}`,
      children: /*#__PURE__*/jsx(ReplyIcon, {
        transform: 'matrix(-1, 0, 0, 1, 0, 0)',
        color: 'primary'
      })
    }),
    download: /*#__PURE__*/jsx(IconButton, {
      "aria-label": `download${ariaLabelShortPrefix}`,
      children: /*#__PURE__*/jsx(FileDownloadIcon, {
        color: 'primary'
      })
    }),
    arrow: /*#__PURE__*/jsx(IconButton, {
      "aria-label": `expand${ariaLabelShortPrefix}`,
      children: /*#__PURE__*/jsx(KeyboardArrowDownIcon, {
        fontSize: 'large',
        sx: {
          color: theme.palette.grey[400]
        }
      })
    }),
    search: /*#__PURE__*/jsx(SearchIcon, {})
  };
};
const TextFieldInputAdornment = ({
  icon,
  endTooltipProps,
  endTooltip,
  onIconClick,
  editButtonLabel,
  editButton,
  icons,
  innerLabel,
  displayAsValid,
  disabled,
  name,
  label
}) => {
  const theme = useTheme();
  const handleIconClick = (e, onClickIcon, iconName) => {
    e.target.dispatchEvent(new CustomEvent('custom:iconclick', {
      bubbles: true,
      detail: {
        name,
        tag: iconName
      }
    }));
    onClickIcon == null ? void 0 : onClickIcon(e);
  };
  return /*#__PURE__*/jsxs(StyledInputAdornment, {
    position: 'end',
    sx: {
      gap: 1
    },
    children: [innerLabel && /*#__PURE__*/jsx(InnerLabel, {
      "aria-atomic": "true",
      "aria-live": "polite",
      children: innerLabel
    }), displayAsValid && /*#__PURE__*/jsx(CheckRoundedIcon, {
      fontSize: 'small',
      color: 'success',
      "aria-hidden": "false",
      "aria-label": `${label} valid`,
      "aria-live": "polite",
      role: "alert"
    }), (icons || icon) && Object.entries(icons || {
      [icon]: {
        onClickIcon: onIconClick
      }
    }).reverse().map(([name, data]) => /*#__PURE__*/React.cloneElement(fieldIcons(theme, data.fieldName)[name], data.onClickIcon ? {
      key: name,
      onMouseDown: e => {
        handleIconClick(e, data.onClickIcon, name);
      },
      onClick: e => {
        handleIconClick(e, data.onClickIcon, name);
      },
      onTouchEnd: e => {
        handleIconClick(e, data.onClickIcon, name);
      },
      style: disabled ? {
        cursor: 'not-allowed'
      } : {
        cursor: 'pointer'
      }
    } : {
      key: name
    })), endTooltip ? /*#__PURE__*/jsx(Tooltip, Object.assign({
      content: endTooltip
    }, endTooltipProps != null ? endTooltipProps : {}, {
      inputName: name
    })) : null, editButton && /*#__PURE__*/jsx(StyledEditButton, {
      "aria-label": 'edit ' + label,
      icon: "edit",
      variant: "textWithIcon",
      onClick: editButton,
      children: editButtonLabel
    })]
  });
};
const TextField = /*#__PURE__*/React.forwardRef((props, ref) => {
  const [toggleInlineTooltip, setToggleInlineTooltip] = useState(false);
  const {
      fsMask = 'mask',
      error,
      helperText: helperTextProp,
      displayAsValid = false,
      icons,
      endTooltip,
      number = false,
      innerLabel,
      onChange,
      inputComponent,
      editButton,
      disabled,
      icon,
      inputProps,
      InputProps,
      tooltipVariant = 'default',
      onFocus,
      onBlur
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded$m);
  const inputAdornmentProps = Object.assign({}, props, {
    endTooltip: tooltipVariant === 'default' && endTooltip
  });
  const shouldUseInlineTooltip = endTooltip && tooltipVariant === 'inline';
  const shouldShowEndAdornment = displayAsValid || icons || icon || innerLabel || editButton || inputAdornmentProps.endTooltip;
  const helperText = useMemo(() => {
    const errorOrHelperText = error ? /*#__PURE__*/jsx(ErrorText, {
      helperText: helperTextProp
    }) : helperTextProp ? helperTextProp : undefined;
    return shouldUseInlineTooltip || errorOrHelperText ? /*#__PURE__*/jsxs(Fragment, {
      children: [errorOrHelperText, shouldUseInlineTooltip && /*#__PURE__*/jsx(InlineTooltip, {
        toggle: toggleInlineTooltip,
        tooltip: endTooltip
      })]
    }) : undefined;
  }, [error, helperTextProp, shouldUseInlineTooltip, toggleInlineTooltip, endTooltip]);
  const onChangeHandler = e => {
    if (number) {
      onChange == null ? void 0 : onChange(Object.assign({}, e, {
        target: Object.assign({}, e.target, {
          value: !isNaN(+e.target.value) ? Number(e.target.value) : e.target.value
        })
      }));
    } else {
      onChange == null ? void 0 : onChange(e);
    }
  };
  const onFocusHandler = e => {
    if (shouldUseInlineTooltip) {
      setToggleInlineTooltip(true);
    }
    onFocus == null ? void 0 : onFocus(e);
  };
  const onBlurHandler = e => {
    if (shouldUseInlineTooltip) {
      setToggleInlineTooltip(false);
    }
    onBlur == null ? void 0 : onBlur(e);
  };
  const dataTestId = props['data-test-id'];
  return /*#__PURE__*/jsx(TextField$1, Object.assign({}, rest, {
    className: `fs-${fsMask}`,
    "data-test-id": dataTestId || 'text-field',
    variant: 'outlined',
    fullWidth: true,
    onChange: onChangeHandler,
    onBlur: onBlurHandler,
    onFocus: onFocusHandler,
    error: !!error,
    size: 'small',
    disabled: disabled || !!editButton,
    helperText,
    inputProps: Object.assign({}, inputProps, {
      autoComplete: (inputProps == null ? void 0 : inputProps['autoComplete']) || 'off'
    }),
    InputProps: Object.assign({}, InputProps, {
      inputComponent
    }, ref && {
      ref
    }, shouldShowEndAdornment && {
      endAdornment: /*#__PURE__*/jsx(TextFieldInputAdornment, Object.assign({}, inputAdornmentProps))
    })
  }));
});

const ExpandIcon$1 = styled$1(ExpandMoreRoundedIcon, {
  shouldForwardProp
})(({
  isOpen,
  theme,
  disabled
}) => Object.assign({
  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  height: '36px'
}, disabled && {
  color: theme.palette.grey['400']
}));

// eslint-disable-next-line @typescript-eslint/naming-convention
function Autocomplete({
  label,
  options,
  placeholder,
  value,
  onChange,
  getOptionLabel,
  isOptionEqualToValue,
  onFocus,
  onBlur,
  disabled,
  dataTestId,
  showCheckIcon = true,
  error,
  helperText,
  fsMask = 'mask',
  noOptionsText,
  withSearch,
  autoComplete = 'off'
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  const onArroClick = () => {
    if (!disabled) {
      setIsOpen(prev => !prev);
    }
  };
  return /*#__PURE__*/jsx(Autocomplete$1, {
    autoHighlight: true,
    clearOnBlur: true,
    disableClearable: true,
    fullWidth: true,
    handleHomeEndKeys: true,
    selectOnFocus: true,
    "data-test-id": dataTestId != null ? dataTestId : 'autocomplete',
    disabled: disabled,
    disablePortal: true,
    getOptionLabel: getOptionLabel,
    isOptionEqualToValue: isOptionEqualToValue,
    ListboxProps: {
      className: `fs-${fsMask}`
    },
    noOptionsText: /*#__PURE__*/jsx("span", {
      "aria-label": 'availible options',
      "aria-live": "polite",
      role: "alert",
      children: noOptionsText != null ? noOptionsText : 'No options'
    }),
    open: isOpen,
    options: options,
    renderInput: params => {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        jsx(TextField, Object.assign({}, params, {
          "data-test-id": "autocomplete-input",
          error: error,
          fsMask: fsMask,
          helperText: helperText,
          InputProps: Object.assign({}, params.InputProps, {
            endAdornment: /*#__PURE__*/jsxs(InputAdornment, {
              position: 'end',
              children: [showCheckIcon && !!value && /*#__PURE__*/jsx(CheckRoundedIcon, {
                "aria-label": `${label} valid`,
                "aria-live": "polite",
                fontSize: 'small',
                color: 'success'
              }), /*#__PURE__*/jsx(ExpandIcon$1, {
                disabled: disabled,
                isOpen: isOpen,
                onClick: withSearch ? onArroClick : undefined
              })]
            })
          }),
          inputProps: Object.assign({}, params.inputProps, {
            disabled: !withSearch || disabled,
            autoComplete
          }),
          label: label,
          placeholder: placeholder,
          size: "small",
          onClick: withSearch ? undefined : onArroClick
        }))
      );
    },
    value: value,
    onBlur: onBlur,
    onChange: onChange,
    onClose: handleClose,
    onFocus: onFocus,
    onOpen: withSearch ? handleOpen : undefined
  });
}

var BusinessFinancing = "data:image/svg+xml,%3Csvg%20width%3D%2234%22%20height%3D%2230%22%20viewBox%3D%220%200%2034%2030%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M31.9998%2014.3442V27.4627C31.9998%2027.7991%2031.8661%2028.1216%2031.6283%2028.3594C31.3905%2028.5972%2031.068%2028.7309%2030.7316%2028.7309H3.24058C2.90424%2028.7309%202.58174%2028.5972%202.34391%2028.3594C2.10609%2028.1216%201.97238%2027.7991%201.97238%2027.4627V14.302%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M30.7143%2022.7145L23.8571%2027.2859L30.7143%2027.2859L30.7143%2022.7145Z%22%20fill%3D%22%2308A4B9%22%2F%3E%3Cpath%20d%3D%22M15.1329%2015.5419C10.5515%2015.4523%205.98306%2015.0237%201.46493%2014.2596C1.33435%2014.2337%201.21683%2014.1633%201.1321%2014.0606C1.04737%2013.9579%201.00069%2013.8291%201%2013.696V6.32654C1%205.9902%201.13353%205.6677%201.37136%205.42988C1.60919%205.19205%201.93186%205.05834%202.2682%205.05834H31.7318C32.0681%205.05834%2032.3908%205.19205%2032.6286%205.42988C32.8665%205.6677%2033%205.9902%2033%206.32654V13.7101C32.9987%2013.8452%2032.9501%2013.9757%2032.8626%2014.0787C32.775%2014.1817%2032.6541%2014.2507%2032.521%2014.2737C28.0029%2015.0384%2023.4343%2015.4671%2018.8528%2015.556%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M18.12%2013.6961H15.8656C15.4609%2013.6961%2015.1328%2014.0242%2015.1328%2014.4288V16.6833C15.1328%2017.088%2015.4609%2017.416%2015.8656%2017.416H18.12C18.5247%2017.416%2018.8528%2017.088%2018.8528%2016.6833V14.4288C18.8528%2014.0242%2018.5247%2013.6961%2018.12%2013.6961Z%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.9678%205.04435V2.40939C23.9678%202.03568%2023.8194%201.67738%2023.5551%201.41313C23.2909%201.14887%2022.9324%201.00031%2022.5587%201.00031H11.5822C11.1992%200.996233%2010.8295%201.14089%2010.551%201.40367C10.2724%201.66645%2010.1067%202.02688%2010.0885%202.40939V5.04435%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

var PersonalFinancing = "data:image/svg+xml,%3Csvg%20width%3D%2229%22%20height%3D%2234%22%20viewBox%3D%220%200%2029%2034%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M25.1867%2030.5908L27.6907%2022.1756C27.7532%2021.961%2027.7652%2021.735%2027.7256%2021.5151C27.686%2021.2951%2027.596%2021.0874%2027.4626%2020.9081C27.3292%2020.7289%2027.156%2020.583%2026.9567%2020.4819C26.7574%2020.3809%2026.5374%2020.3274%2026.3139%2020.3256H3.08187C2.8577%2020.326%202.63671%2020.3785%202.43633%2020.479C2.23595%2020.5796%202.0617%2020.7253%201.92733%2020.9047C1.79296%2021.0841%201.70206%2021.2924%201.66201%2021.513C1.62197%2021.7335%201.63396%2021.9604%201.69667%2022.1756L4.18327%2030.5908H14.7151%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.46221%2028.8699L1.12848%2031.3824C1.03977%2031.5495%200.995665%2031.7367%201.00034%2031.9259C1.00501%2032.115%201.05831%2032.2998%201.15516%2032.4624C1.252%2032.6249%201.38911%2032.7598%201.55324%2032.854C1.71737%2032.9481%201.90306%2032.9984%202.09228%2033H27.329C27.5192%2033.0009%2027.7065%2032.9522%2027.872%2032.8586C28.0376%2032.7651%2028.1757%2032.6299%2028.2731%2032.4665C28.3704%2032.3032%2028.4234%2032.1172%2028.4268%2031.9271C28.4303%2031.7369%2028.3842%2031.5492%2028.2928%2031.3824L26.9591%2028.8699%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.3983%2026.1767L8.83833%2021.7367H3.082L4.3983%2026.1767Z%22%20fill%3D%22%23395AC9%22%2F%3E%3Cpath%20d%3D%22M20.2479%206.08527C20.2479%207.09103%2019.9496%208.07418%2019.3908%208.91044C18.832%209.7467%2018.0378%2010.3985%2017.1086%2010.7834C16.1794%2011.1683%2015.157%2011.269%2014.1705%2011.0727C13.1841%2010.8765%2012.2779%2010.3922%2011.5667%209.68103C10.8555%208.96985%2010.3712%208.06376%2010.175%207.07732C9.97881%206.09088%2010.0796%205.06844%2010.4645%204.13923C10.8494%203.21003%2011.5012%202.41581%2012.3375%201.85703C13.1737%201.29826%2014.1569%201%2015.1627%201C16.5114%201%2017.8048%201.53578%2018.7585%202.48945C19.7121%203.44311%2020.2479%204.73658%2020.2479%206.08527V6.08527Z%22%20stroke%3D%22%232A3156%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.3025%2017.6238V15.6792C23.3012%2015.2002%2023.1941%2014.7273%2022.9888%2014.2945C22.7836%2013.8616%2022.4851%2013.4795%2022.1149%2013.1753L19.6714%2011.1619%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.07436%2018.2089V15.6839C7.0756%2015.2217%207.17708%2014.7655%207.37165%2014.3479C7.56621%2013.9302%207.84917%2013.5615%208.19998%2013.2681L10.5161%2011.3254%22%20stroke%3D%22%232A3156%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";

const BoxContainer = styled$1(Box)(({
  theme,
  color
}) => ({
  padding: 0,
  background: 'white',
  width: '100%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.grey[400]}`,
  borderRadius: theme.spacing(0.5),
  cursor: 'pointer',
  boxShadow: `0px 2px 8px ${color}29`
}));
const Content$1 = styled$1('div')(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(3),
  '& > *:not(:last-child)': {
    marginBottom: '16px'
  },
  pointerEvents: 'none'
}));
const ContentTitle = styled$1(Typography)({
  color: 'inherit',
  pointerEvents: 'none'
});
const StyledLabel = styled$1('div')(({
  color
}) => ({
  width: '100%',
  height: 36,
  background: color,
  borderRadius: '0px 0px 4x 4px',
  boxShadow: '0px 4px 12px rgba(75, 119, 255, 0.3)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: 'none',
  pointerEvents: 'none'
}));
const StyledImage$1 = styled$1('img')({
  height: 32
});
const BoxWithActionButton = ({
  colorKey,
  icon,
  title,
  buttonText,
  action,
  dataTestId,
  trackId
}) => {
  const boxProps = {
    type: 'button',
    component: 'button',
    'track-id': trackId,
    'data-test-id': dataTestId,
    onClick: action,
    color: colorKey
  };
  return /*#__PURE__*/jsxs(BoxContainer, Object.assign({}, boxProps, {
    children: [/*#__PURE__*/jsxs(Content$1, {
      children: [icon, /*#__PURE__*/jsx(ContentTitle, {
        color: colorKey,
        variant: "h5",
        children: title
      })]
    }), /*#__PURE__*/jsx(StyledLabel, {
      color: colorKey,
      children: /*#__PURE__*/jsx(Typography, {
        color: "#FFF",
        fontWeight: 700,
        sx: {
          pointerEvents: 'none'
        },
        variant: "body1",
        children: buttonText
      })
    })]
  }));
};
const SelectionContainer = styled$1('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row'
  }
}));
const BoxSelection = ({
  items,
  firstColor,
  secondColor
}) => {
  const {
    secondBox,
    firstBox
  } = items;
  const theme = useTheme();
  const firstBoxColor = firstColor || theme.palette['primary'].main;
  const secondBoxColor = secondColor || theme.palette['secondary'].main;
  return /*#__PURE__*/jsxs(SelectionContainer, {
    "data-test-id": "box-selection-container",
    children: [/*#__PURE__*/jsx(BoxWithActionButton, Object.assign({
      colorKey: firstBoxColor,
      dataTestId: "box-first-button",
      icon: /*#__PURE__*/jsx(StyledImage$1, {
        alt: firstBox.title,
        src: PersonalFinancing
      })
    }, firstBox)), /*#__PURE__*/jsx(BoxWithActionButton, Object.assign({
      colorKey: secondBoxColor,
      dataTestId: "box-second-button",
      icon: /*#__PURE__*/jsx(StyledImage$1, {
        alt: secondBox.title,
        src: BusinessFinancing
      })
    }, secondBox))]
  });
};

const _excluded$l = ["label", "dataTestId", "checkboxPosition", "fullWidth", "displayVisibility", "error", "helperText"];
const StyledHelperText = styled(FormHelperText, {
  shouldForwardProp
})({
  marginLeft: 0,
  marginBottom: 3
});
const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp
})(({
  checkboxPosition,
  fullWidth,
  displayVisibility,
  theme,
  error
}) => {
  return Object.assign({
    alignItems: checkboxPosition === 'top' ? 'flex-start' : checkboxPosition,
    width: fullWidth ? '100%' : 'auto',
    marginRight: 0,
    'span.MuiTypography-root': {
      marginLeft: 7
    },
    'span.MuiCheckbox-root': Object.assign({
      padding: checkboxPosition === 'top' ? `2px 9px 9px 9px` : '9px'
    }, error && {
      'svg.MuiSvgIcon-root': {
        color: theme.palette.error.main
      }
    })
  }, displayVisibility && {
    display: displayVisibility
  });
});
const Checkbox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      label,
      dataTestId,
      checkboxPosition = 'center',
      fullWidth = false,
      displayVisibility,
      error,
      helperText
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$l);
  return /*#__PURE__*/jsxs(FormControl, {
    error: error,
    fullWidth: fullWidth,
    children: [/*#__PURE__*/jsx(StyledFormControlLabel, {
      ref: ref,
      checkboxPosition: checkboxPosition,
      control: /*#__PURE__*/jsx(Checkbox$1, Object.assign({}, rest)),
      "data-test-id": dataTestId != null ? dataTestId : 'checkbox',
      displayVisibility: displayVisibility,
      error: error,
      fullWidth: fullWidth,
      label: label
    }), helperText && /*#__PURE__*/jsx(StyledHelperText, {
      children: helperText
    })]
  });
});

var anObject$8 = anObject$e;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$8(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$a = fails$m;
var global$9 = global$l;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$9.RegExp;

var UNSUPPORTED_Y$2 = fails$a(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY$1 = UNSUPPORTED_Y$2 || fails$a(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$a(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var fails$9 = fails$m;
var global$8 = global$l;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$8.RegExp;

var regexpUnsupportedDotAll = fails$9(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$8 = fails$m;
var global$7 = global$l;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$7.RegExp;

var regexpUnsupportedNcg = fails$8(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$c = functionCall;
var uncurryThis$b = functionUncurryThis;
var toString$5 = toString$7;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$4 = uncurryThis$b(''.charAt);
var indexOf$1 = uncurryThis$b(''.indexOf);
var replace$2 = uncurryThis$b(''.replace);
var stringSlice$5 = uncurryThis$b(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$c(nativeExec, re1, 'a');
  call$c(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$5(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$c(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$c(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$5(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$4(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$c(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$5(match.input, charsAdded);
        match[0] = stringSlice$5(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$c(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$a = _export;
var exec$2 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$a({ target: 'RegExp', proto: true, forced: /./.exec !== exec$2 }, {
  exec: exec$2
});

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$b = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$b.bind(apply$2) : function () {
  return call$b.apply(apply$2, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$a = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$a(fn);
};

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$9 = functionUncurryThisClause;
var defineBuiltIn$4 = defineBuiltIn$8;
var regexpExec$1 = regexpExec$2;
var fails$7 = fails$m;
var wellKnownSymbol$b = wellKnownSymbol$k;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;

var SPECIES$3 = wellKnownSymbol$b('species');
var RegExpPrototype$3 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$b(KEY);

  var DELEGATES_TO_SYMBOL = !fails$7(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$7(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$9(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$9(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$3.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$4(String.prototype, KEY, methods[0]);
    defineBuiltIn$4(RegExpPrototype$3, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$1(RegExpPrototype$3[SYMBOL], 'sham', true);
};

var uncurryThis$8 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$4 = toString$7;
var requireObjectCoercible$3 = requireObjectCoercible$6;

var charAt$3 = uncurryThis$8(''.charAt);
var charCodeAt = uncurryThis$8(''.charCodeAt);
var stringSlice$4 = uncurryThis$8(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$4(requireObjectCoercible$3($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$3(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$4(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var uncurryThis$7 = functionUncurryThis;
var toObject$1 = toObject$5;

var floor = Math.floor;
var charAt$1 = uncurryThis$7(''.charAt);
var replace$1 = uncurryThis$7(''.replace);
var stringSlice$3 = uncurryThis$7(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$2 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$1(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$1(ch, 1) : captures[f - 1] + charAt$1(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$a = functionCall;
var anObject$7 = anObject$e;
var isCallable$8 = isCallable$p;
var classof$4 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$9 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$8(exec)) {
    var result = call$a(exec, R, S);
    if (result !== null) anObject$7(result);
    return result;
  }
  if (classof$4(R) === 'RegExp') return call$a(regexpExec, R, S);
  throw $TypeError$9('RegExp#exec called on incompatible receiver');
};

var apply$1 = functionApply;
var call$9 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$6 = fails$m;
var anObject$6 = anObject$e;
var isCallable$7 = isCallable$p;
var isNullOrUndefined$3 = isNullOrUndefined$6;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength = toLength$2;
var toString$3 = toString$7;
var requireObjectCoercible$2 = requireObjectCoercible$6;
var advanceStringIndex = advanceStringIndex$1;
var getMethod$3 = getMethod$5;
var getSubstitution$1 = getSubstitution$2;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol$a = wellKnownSymbol$k;

var REPLACE$1 = wellKnownSymbol$a('replace');
var max$1 = Math.max;
var min = Math.min;
var concat = uncurryThis$6([].concat);
var push = uncurryThis$6([].push);
var stringIndexOf$3 = uncurryThis$6(''.indexOf);
var stringSlice$2 = uncurryThis$6(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE$1]) {
    return /./[REPLACE$1]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$6(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$2(this);
      var replacer = isNullOrUndefined$3(searchValue) ? undefined : getMethod$3(searchValue, REPLACE$1);
      return replacer
        ? call$9(replacer, searchValue, O, replaceValue)
        : call$9(nativeReplace, toString$3(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$6(this);
      var S = toString$3(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$3(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$3(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$7(replaceValue);
      if (!functionalReplace) replaceValue = toString$3(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$3(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$3(result[0]);
        var position = max$1(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString$3(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution$1(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$2(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$2(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

const _excluded$k = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "beforeMaskedStateChange", "showPlaceHolderWhenLabelPresented", "value", "disabled", "maskPlaceholder", "useUnmaskedValue", "mask"];
const MaskedTextField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      onChange,
      onPaste,
      onMouseDown,
      onFocus,
      onBlur,
      beforeMaskedStateChange,
      showPlaceHolderWhenLabelPresented,
      value,
      disabled,
      maskPlaceholder = null,
      useUnmaskedValue = true,
      mask = ''
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  const onChangeWrapper = e => {
    var _e$target$value;
    mask && useUnmaskedValue && (e.target.value = (_e$target$value = e.target.value) == null ? void 0 : _e$target$value.replace(/[^\d|\w]/g, ''));
    return onChange == null ? void 0 : onChange(e);
  };
  return /*#__PURE__*/jsx(ReactInputMask, {
    beforeMaskedStateChange: beforeMaskedStateChange,
    disabled: disabled,
    mask: mask,
    maskPlaceholder: maskPlaceholder,
    value: value,
    onBlur: onBlur,
    onChange: onChangeWrapper,
    onFocus: onFocus,
    onMouseDown: onMouseDown,
    onPaste: onPaste,
    children: /*#__PURE__*/jsx(TextField, Object.assign({}, rest, {
      ref: ref,
      InputLabelProps: {
        shrink: showPlaceHolderWhenLabelPresented
      },
      value: value,
      onChange: onChangeWrapper
    }))
  });
});

const _excluded$j = ["value", "inputProps", "shouldBeHidden", "onChange", "onBlur", "onFocus", "inputRef", "maskingType"],
  _excluded2$2 = ["value"];
const SecretTextField = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _rest$label, _rest$label2;
  let {
      value,
      inputProps,
      shouldBeHidden = true,
      onChange,
      onBlur: parentOnBlur,
      onFocus: parentOnFocus,
      inputRef: parentInputRef,
      maskingType = 'blurHidden'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$j);
  const _ref2 = inputProps || {},
    {
      value: inputValue
    } = _ref2,
    restInputProps = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);
  const inputRef = useRef(null);
  const [timeout, setTimeoutId] = useState(null);
  const [secretValue, setSecretValue] = useState(value || inputValue || '');
  const [hiddenData, setHiddenData] = useState({
    hidden: true
  });
  const onChangeSecret = event => {
    setSecretValue(event.target.value);
    onChange == null ? void 0 : onChange(event);
  };
  const handleTimer = () => {
    if (timeout !== null) clearTimeout(timeout);
    setHiddenData(state => Object.assign({}, state, {
      hidden: true
    }));
    setTimeoutId(null);
  };
  const onClickEye = e => {
    e.preventDefault();
    e.stopPropagation();
    if (hiddenData.hidden) {
      setTimeoutId(setTimeout(handleTimer, 3000));
      setHiddenData(state => Object.assign({}, state, {
        hidden: false
      }));
    } else {
      handleTimer();
    }
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const onFocus = ev => {
    if (maskingType === 'blurHidden') {
      setHiddenData(state => Object.assign({}, state, {
        hidden: false
      }));
    }
    parentOnFocus == null ? void 0 : parentOnFocus(ev);
  };
  const onBlur = ev => {
    handleTimer();
    parentOnBlur == null ? void 0 : parentOnBlur(ev);
  };
  useEffect(() => {
    setSecretValue(typeof value === 'string' ? value : typeof inputValue === 'string' ? inputValue : secretValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, inputValue]);
  useLayoutEffect(() => {
    if (parentInputRef) {
      if (typeof parentInputRef === 'function') {
        parentInputRef(inputRef.current);
      } else {
        parentInputRef.current = inputRef.current;
      }
    }
  }, [parentInputRef]);
  return /*#__PURE__*/jsx(MaskedTextField, Object.assign({}, rest, {
    ref: ref,
    icons: Object.assign({}, rest.icon && {
      [rest.icon]: {
        onClickIcon: rest.onIconClick,
        fieldName: (_rest$label = rest.label) != null ? _rest$label : rest.name
      }
    }, rest.icons, shouldBeHidden && maskingType === 'timerHidden' && {
      [hiddenData.hidden ? 'visibility' : 'visibilityHidden']: {
        onClickIcon: onClickEye,
        fieldName: (_rest$label2 = rest.label) != null ? _rest$label2 : rest.name
      }
    }),
    inputProps: Object.assign({}, restInputProps, {
      type: hiddenData.hidden && shouldBeHidden ? 'password' : rest.type || 'text'
    }),
    inputRef: inputRef,
    value: secretValue,
    onBlur: onBlur,
    onChange: onChangeSecret,
    onFocus: onFocus
  }));
});

const _excluded$i = ["inputRef"];
const CreditCardCvcField = props => {
  const {
      inputRef
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$i);
  return /*#__PURE__*/jsx(SecretTextField, Object.assign({}, other, {
    ref: inputRef,
    "data-test-id": "credit-card-cvc-field",
    mask: other.mask || '9999'
  }));
};

var call$8 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf$3 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$2(R, 'flags') && isPrototypeOf$3(RegExpPrototype$2, R)
    ? call$8(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$3 = defineBuiltIn$8;
var anObject$5 = anObject$e;
var $toString = toString$7;
var fails$5 = fails$m;
var getRegExpFlags$2 = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$5(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$3(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$5(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags$2(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

var aCallable$6 = aCallable$9;
var toObject = toObject$5;
var IndexedObject = indexedObject;
var lengthOfArrayLike$1 = lengthOfArrayLike$3;

var $TypeError$8 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable$6(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$1(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$8('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var fails$4 = fails$m;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$4(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var classof$3 = classofRaw$2;

var engineIsNode = typeof process != 'undefined' && classof$3(process) == 'process';

var $$9 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE$4 = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE$4 && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$9({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var isObject$3 = isObject$a;
var classof$2 = classofRaw$2;
var wellKnownSymbol$9 = wellKnownSymbol$k;

var MATCH$2 = wellKnownSymbol$9('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$3(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
};

var $$8 = _export;
var call$7 = functionCall;
var uncurryThis$5 = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var isCallable$6 = isCallable$p;
var isNullOrUndefined$2 = isNullOrUndefined$6;
var isRegExp$2 = isRegexp;
var toString$2 = toString$7;
var getMethod$2 = getMethod$5;
var getRegExpFlags$1 = regexpGetFlags;
var getSubstitution = getSubstitution$2;
var wellKnownSymbol$8 = wellKnownSymbol$k;

var REPLACE = wellKnownSymbol$8('replace');
var $TypeError$7 = TypeError;
var indexOf = uncurryThis$5(''.indexOf);
uncurryThis$5(''.replace);
var stringSlice$1 = uncurryThis$5(''.slice);
var max = Math.max;

var stringIndexOf$2 = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$$8({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible$1(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (!isNullOrUndefined$2(searchValue)) {
      IS_REG_EXP = isRegExp$2(searchValue);
      if (IS_REG_EXP) {
        flags = toString$2(requireObjectCoercible$1(getRegExpFlags$1(searchValue)));
        if (!~indexOf(flags, 'g')) throw $TypeError$7('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod$2(searchValue, REPLACE);
      if (replacer) {
        return call$7(replacer, searchValue, O, replaceValue);
      }
    }
    string = toString$2(O);
    searchString = toString$2(searchValue);
    functionalReplace = isCallable$6(replaceValue);
    if (!functionalReplace) replaceValue = toString$2(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf$2(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString$2(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice$1(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf$2(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice$1(string, endOfLastMatch);
    }
    return result;
  }
});

// 3333-11-22

const testDate = new Date(3333, 10, 22);
const replacements = {
  '1': 'M',
  '2': 'd',
  '3': 'y'
};
const getInputFormat = intlInstance => {
  const testDateFormatted = intlInstance.formatDate(testDate);
  return Object.keys(replacements).reduce((format, digit) => {
    // probs, we need to update lib compiler option to es2021
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return format.replaceAll(digit, replacements[digit]);
  }, testDateFormatted);
};
const getInputMask = (mask, replacer = '_') => {
  return mask.replace(/[A-Za-z0-9]/g, replacer);
};
const birthMaxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18));
const birthMinDate = new Date(1900, 1, 1);
const formatDateFromString = (dateString, format) => {
  const date = parse(dateString, format, testDate);
  return date;
};

const _excluded$h = ["value", "onChange", "maxDate", "minDate", "helperText", "error", "defaultCalendarMonth", "displayAsValid", "disabled", "inputFormat", "shouldBeHidden", "onBlur", "openTo", "fsMask", "placeholder", "showPlaceHolderWhenLabelPresented", "maskingType"];
const handleMinMaxCalendarAda = (minDate, maxDate, defaultDate) => {
  var _date;
  const currentDate = new Date();
  let date = defaultDate;
  if (!date) {
    if (minDate && minDate.getFullYear() > currentDate.getFullYear()) {
      date = minDate;
    }
    if (maxDate && maxDate.getFullYear() < currentDate.getFullYear()) {
      date = maxDate;
    }
  }
  if (((_date = date) == null ? void 0 : _date.toString()) !== 'Invalid Date') {
    return date;
  }
  return;
};
const useDatePickerProps = props => {
  const intl = useIntl();
  const {
      value = null,
      onChange,
      maxDate,
      minDate,
      helperText,
      error,
      defaultCalendarMonth,
      displayAsValid = false,
      disabled = false,
      inputFormat,
      shouldBeHidden = true,
      onBlur,
      openTo,
      fsMask = 'mask',
      placeholder,
      showPlaceHolderWhenLabelPresented,
      maskingType
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded$h);
  const ignorePatternsDatePicker = {
    'data-test-id': 'date-picker',
    date: handleMinMaxCalendarAda(minDate, maxDate, value || defaultCalendarMonth)
  };
  const ignorePatternsSecretField = {
    'data-test-id': 'date-picker-input'
  };
  const onChangePicker = useCallback(newValue => {
    onChange(newValue);
  }, [onChange]);
  const datePickerProps = {
    muiDatePickerProps: Object.assign({}, rest, ignorePatternsDatePicker, {
      DialogProps: {
        className: `fs-${fsMask}`
      },
      PaperProps: {
        className: `fs-${fsMask}`,
        // unfortunately, we can't use the theme here as its a global paper class which we dont want to override for all
        sx: {
          boxShadow: '0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%)',
          borderRadius: theme => theme.spacing(0.5)
        }
      },
      PopperProps: {
        className: `fs-${fsMask}`,
        placement: 'bottom-end'
      },
      defaultCalendarMonth,
      onChange: onChangePicker,
      disableMaskedInput: false,
      inputFormat: inputFormat || getInputFormat(intl),
      mask: getInputMask(inputFormat || getInputFormat(intl)),
      disabled,
      value,
      minDate,
      maxDate,
      openTo
    }),
    secretFieldProps: Object.assign({}, ignorePatternsSecretField, {
      mask: getInputMask(inputFormat || getInputFormat(intl), '9'),
      error,
      name: rest.name,
      helperText,
      disabled,
      displayAsValid,
      shouldBeHidden,
      useUnmaskedValue: false,
      showPlaceHolderWhenLabelPresented,
      placeholder,
      maskingType,
      onBlur
    }),
    onBlur
  };
  return datePickerProps;
};

const _excluded$g = ["helperText"];
const DatePicker = props => {
  const {
    onBlur,
    muiDatePickerProps,
    secretFieldProps
  } = useDatePickerProps(props);
  const setAriaPressedToAcvtiveElement = useCallback(() => {
    var _document;
    (_document = document) == null || (_document = _document.activeElement) == null ? void 0 : _document.setAttribute('aria-pressed', 'true');
  }, []);
  return /*#__PURE__*/jsx(DatePicker$1, Object.assign({
    renderInput: _ref => {
      var _params$inputProps, _params$InputProps, _params$inputProps2, _params$inputProps3;
      let params = _objectWithoutPropertiesLoose(_ref, _excluded$g);
      params.inputProps = Object.assign({}, params.inputProps, {
        placeholder: secretFieldProps.placeholder || ((_params$inputProps = params.inputProps) == null ? void 0 : _params$inputProps.placeholder)
      });
      return /*#__PURE__*/jsx(SecretTextField, Object.assign({}, params, secretFieldProps, {
        ref: params.inputRef,
        icons: Object.assign({}, !props.disableOpenPicker && {
          calendar: {
            onClickIcon: !secretFieldProps.disabled && (params == null || (_params$InputProps = params.InputProps) == null || (_params$InputProps = _params$InputProps.endAdornment) == null || (_params$InputProps = _params$InputProps.props) == null || (_params$InputProps = _params$InputProps.children) == null || (_params$InputProps = _params$InputProps.props) == null ? void 0 : _params$InputProps.onClick)
          }
        }),
        value: (_params$inputProps2 = params.inputProps) == null ? void 0 : _params$inputProps2['value'],
        onChange: (_params$inputProps3 = params.inputProps) == null ? void 0 : _params$inputProps3.onChange
      }));
    },
    onClose: () => {
      onBlur == null ? void 0 : onBlur({});
    },
    onMonthChange: setAriaPressedToAcvtiveElement,
    onYearChange: setAriaPressedToAcvtiveElement
  }, muiDatePickerProps));
};

const _excluded$f = ["useShortenedYearFormat"],
  _excluded2$1 = ["onChange"];
const CreditCardExpiryDatePickerField = _ref => {
  let {
      useShortenedYearFormat = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  const {
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded2$1);
  const inputFormat = useShortenedYearFormat ? 'MM/yy' : 'MM/yyyy';
  const mask = useShortenedYearFormat ? '__/__' : '__/____';
  return /*#__PURE__*/jsx(DatePicker, Object.assign({}, other, {
    disableMaskedInput: false,
    inputFormat: inputFormat,
    mask: mask,
    views: ['month', 'year'],
    onChange: onChange
  }));
};

const _excluded$e = ["inputRef"];
const CreditCardExpiryField = props => {
  const {
      inputRef
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$e);
  return /*#__PURE__*/jsx(SecretTextField, Object.assign({}, other, {
    ref: inputRef,
    "data-test-id": "credit-card-expiry",
    mask: other.mask || '99/9999'
  }));
};

const _excluded$d = ["inputRef"];
const CreditCardPanField = props => {
  const {
      inputRef
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$d);
  return /*#__PURE__*/jsx(SecretTextField, Object.assign({}, other, {
    ref: inputRef,
    "data-test-id": "credit-card-pan-field",
    mask: other.mask || '9999 9999 9999 9999'
  }));
};

const _excluded$c = ["inputRef", "onChange", "maxLength", "isAllowed", "name", "prefix"];
const CurrencyField = props => {
  const {
      inputRef,
      onChange,
      maxLength,
      isAllowed,
      name,
      prefix = '$'
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded$c);
  const numberFieldProps = rest;
  const isAllowedInternal = values => {
    // remove decimal values from maxLength calculation
    const value = values.value.split('.')[0];
    return (maxLength ? value.length <= maxLength : true) && (isAllowed ? isAllowed(values) : true);
  };
  return /*#__PURE__*/jsx(NumberFormat, Object.assign({}, numberFieldProps, {
    allowNegative: false,
    autoComplete: "off",
    customInput: TextField,
    "data-test-id": "currency-field",
    inputRef: inputRef,
    isAllowed: isAllowedInternal,
    name: name,
    prefix: prefix,
    thousandSeparator: true,
    onValueChange: ({
      value
    }) => {
      onChange == null ? void 0 : onChange({
        target: {
          value,
          name
        }
      });
    }
  }));
};
var CurrencyField$1 = CurrencyField;

const Container$6 = styled('div')(({
  width
}) => ({
  width,
  position: 'relative'
}));
const Circle$1 = styled('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.primary.light,
  height: 11,
  borderRadius: '50%',
  left: 0,
  width: 11,
  top: -4,
  position: 'relative',
  flex: '0 0 auto',
  transform: 'translate(-8px, -0px)',
  marginRight: theme.spacing(1),
  border: `8px solid white`,
  '*[dir="rtl"] &': {
    left: 'unset',
    right: 0,
    marginRight: 'unset',
    marginLeft: theme.spacing(1),
    transform: 'translate(8px, -0px)'
  }
}));
const MessageContainer = styled('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'start',
  position: 'relative',
  '&:not(:last-of-type):after': {
    content: '""',
    backgroundColor: theme.palette.primary.light,
    position: 'absolute',
    height: '100%',
    top: 4,
    width: 3,
    left: 4,
    zIndex: -1,
    '*[dir="rtl"] &': {
      left: 'unset',
      right: 4
    }
  }
}));
const DeclineMessages = ({
  messages,
  width: _width = '100%',
  variant: _variant = 'body1',
  dataTestId
}) => {
  if (messages.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx(Container$6, {
    width: _width,
    "data-test-id": dataTestId || 'declines',
    children: messages.map((message, idx) => {
      return /*#__PURE__*/jsxs(MessageContainer, {
        children: [/*#__PURE__*/jsx(Circle$1, {}), /*#__PURE__*/jsx(Typography, {
          variant: _variant,
          children: message
        })]
      }, idx);
    })
  });
};

const Container$5 = styled$1('div')(({
  theme
}) => ({
  border: `2px solid ${theme.palette.grey[200]}`,
  borderRadius: `5px 5px 2px 2px`,
  position: 'relative'
}));
const Title$1 = styled$1(Typography)(({
  theme
}) => Object.assign({}, theme.typography.body1, {
  background: 'white',
  lineHeight: '1.25rem',
  fontWeight: 500,
  color: theme.palette.grey[400],
  position: 'absolute',
  top: -12,
  left: '50%',
  transform: 'translateX(-50%)',
  padding: `0 ${theme.spacing(1)}`,
  whiteSpace: 'nowrap'
}));
const LogoAndText = styled$1('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(4),
  marginRight: theme.spacing(2)
}));
const Logo$1 = styled$1('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(6),
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    marginRight: 'unset',
    width: theme.spacing(8)
  }
}));
const Divider$1 = styled$1('div')(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'block',
    height: theme.spacing(4),
    width: 2,
    background: theme.palette.grey[200],
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
}));
const DirectSession = ({
  title,
  logo,
  buttonText,
  text,
  onButtonClick
}) => {
  return /*#__PURE__*/jsxs(Container$5, {
    "data-test-id": "credit-card",
    children: [/*#__PURE__*/jsx(Title$1, {
      variant: "h3",
      children: title
    }), /*#__PURE__*/jsxs(LogoAndText, {
      children: [/*#__PURE__*/jsx(Logo$1, {
        children: logo
      }), /*#__PURE__*/jsx(Divider$1, {}), typeof text === 'string' ? /*#__PURE__*/jsx(Typography, {
        variant: 'body2',
        children: text
      }) : text]
    }), /*#__PURE__*/jsx(Button, {
      variant: 'secondary',
      onClick: onButtonClick,
      type: 'button',
      children: buttonText
    })]
  });
};

const _excluded$b = ["message"];
const Container$4 = styled$1('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.primary.lighter,
  padding: theme.spacing(1.5, 2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: 2,
  position: 'relative'
}));
const StyledTooltip$1 = styled$1(Tooltip)({
  padding: 0,
  marginLeft: 'auto',
  marginTop: 0.7
});
const StyledTypography$1 = styled$1(Typography)({
  display: 'inline'
});
const NewContainer = styled$1(Container$4)(({
  theme
}) => ({
  backgroundColor: theme.palette.success.lighter,
  padding: theme.spacing(1, 4),
  margin: '0px -32px',
  alignItems: 'flex-start',
  gap: 8,
  justifyContent: 'flex-start',
  '& > svg': {
    flexShrink: 0
  },
  borderRadius: 0
}));
const FicoScore = _ref => {
  let {
      message
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  const theme = useTheme();
  return /*#__PURE__*/jsxs(NewContainer, {
    children: [options.icon, /*#__PURE__*/jsxs(StyledTypography$1, {
      variant: "body2",
      children: [/*#__PURE__*/jsx(StyledTypography$1, {
        color: theme.palette.success.dark,
        marginRight: 0.5,
        variant: "body1",
        children: options.prefix
      }), message]
    }), options.tooltipContent && /*#__PURE__*/jsx(StyledTooltip$1, {
      content: options.tooltipContent
    })]
  });
};

const FooterContainer$1 = styled$1('footer')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
const Footer = ({
  text
}) => {
  const theme = useTheme();
  return /*#__PURE__*/jsxs(FooterContainer$1, {
    "data-test-id": "footer",
    children: [/*#__PURE__*/jsx(LockRoundedIcon, {
      sx: {
        marginRight: theme.spacing(),
        color: theme.palette.grey[400],
        fontSize: '0.8rem'
      }
    }), /*#__PURE__*/jsx(Typography, {
      variant: 'legal',
      children: text
    })]
  });
};

const Radio = _ref => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/jsx(Radio$1, Object.assign({
    size: "small"
  }, rest, {
    "data-test-id": "radio"
  }));
};

const GroupSelectorContext = /*#__PURE__*/React.createContext({});
const StyledSummary = styled('div')(({
  theme
}) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2)
}));
const StyledSummaryBottom = styled('div')(() => ({
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: '100%'
}));
const StyleAccordion = styled(Accordion$1)(({
  theme
}) => ({
  marginBottom: theme.spacing(2),
  boxShadow: ` 0px 2px 8px rgba(0, 0, 0, 0.1);`,
  border: 'none',
  '&:before': {
    content: 'none'
  }
}));
const StyleAccordionSummary = styled(AccordionSummary$1, {
  shouldForwardProp
})(({
  markSelected,
  theme,
  hasBottom: _hasBottom = false,
  customPadding,
  customPaddingWithBottom,
  customMinHeight
}) => ({
  // border: `1px solid ${theme.palette.grey[200]}`,
  border: 'none',
  minHeight: customMinHeight || theme.spacing(12),
  borderRadius: theme.shape.borderRadius,
  padding: _hasBottom ? customPaddingWithBottom || customPadding || theme.spacing(3, 2, 8) : customPadding || theme.spacing(3, 2),
  '& .MuiAccordionSummary-content': {
    '&, &.Mui-expanded': {
      margin: 0
    }
  },
  '&.Mui-expanded': {
    boxShadow: `0px 0px 0px 2px ${theme.palette.primary.main}`,
    margin: 'unset'
  },
  boxShadow: markSelected ? `0px 0px 0px 2px ${theme.palette.primary.main}` : `0px 0px 0px 1px ${theme.palette.grey[200]}`,
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      border: 'none',
      boxShadow: `0px 0px 0px 2px ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.primary.lighter
    }
  },
  '&, & *': {
    cursor: 'pointer'
  }
}));
const StyleAccordionDetails = styled(AccordionDetails)(({
  theme
}) => ({
  padding: `${theme.spacing(3)}`,
  position: 'relative',
  '&.Mui-expanded': {
    border: `2px solid ${theme.palette.primary.main}`
  }
}));
const InnerSummary = ({
  index,
  start,
  end,
  bottom,
  children,
  dataTestId,
  customMinHeight,
  customPadding,
  customPaddingWithBottom
}) => {
  const {
    onChange,
    value,
    showRadioButton,
    showExpandArrow
  } = React.useContext(GroupSelectorContext);
  const selected = value === index;
  const expandable = !!children;
  return /*#__PURE__*/jsxs(StyleAccordion, {
    "data-test-id": dataTestId || 'accordion',
    expanded: expandable && selected,
    onChange: onChange(index),
    children: [/*#__PURE__*/jsx(StyleAccordionSummary, {
      customMinHeight: customMinHeight,
      customPadding: customPadding,
      customPaddingWithBottom: customPaddingWithBottom,
      expandIcon: expandable && showExpandArrow ? /*#__PURE__*/jsx(ExpandMoreRounded, {}) : undefined,
      hasBottom: !!bottom,
      markSelected: !expandable && selected,
      children: /*#__PURE__*/jsxs(StyledSummary, {
        children: [/*#__PURE__*/jsxs("div", {
          style: {
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            alignItems: 'center'
          },
          children: [showRadioButton && /*#__PURE__*/jsx(Radio, {
            checked: selected,
            inputProps: {
              hidden: true
            }
          }), /*#__PURE__*/jsx("div", {
            children: /*#__PURE__*/React.isValidElement(start) ? start : start == null ? void 0 : start({
              isSelected: selected
            })
          })]
        }), /*#__PURE__*/React.isValidElement(end) ? end : end == null ? void 0 : end({
          isSelected: selected
        }), /*#__PURE__*/React.isValidElement(bottom) ? bottom : bottom && /*#__PURE__*/jsx(StyledSummaryBottom, {
          children: /*#__PURE__*/jsx("div", {
            children: bottom == null ? void 0 : bottom({
              isSelected: selected
            })
          })
        })]
      })
    }), /*#__PURE__*/jsx(StyleAccordionDetails, {
      children: children
    })]
  });
};
const Summary = ({
  start,
  end,
  bottom,
  children
}) => {
  var _React$Children;
  if (!children) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    jsx(Fragment, {
      children: (_React$Children = React.Children) == null || _React$Children.map == null ? void 0 : _React$Children.map(children, child => {
        if (!child || ! /*#__PURE__*/React.isValidElement(child)) {
          return null;
        }
        return /*#__PURE__*/React.cloneElement(child, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          start,
          end,
          bottom
        });
      })
    })
  );
};
const GroupSelector = ({
  value,
  onChange,
  showRadioButton: _showRadioButton = false,
  showExpandArrow: _showExpandArrow = true,
  startIndex: _startIndex = 0,
  children,
  dataTestId,
  customMinHeight,
  customPadding,
  customPaddingWithBottom
}) => {
  const handleChange = ind => (e, isExpanded) => {
    onChange(e, isExpanded ? ind : null);
  };
  return /*#__PURE__*/jsx(GroupSelectorContext.Provider, {
    value: {
      onChange: handleChange,
      showRadioButton: _showRadioButton,
      showExpandArrow: _showExpandArrow,
      value
    },
    children: React.Children.map(children, (child, index) => {
      if (!child || ! /*#__PURE__*/React.isValidElement(child)) {
        return null;
      }
      return /*#__PURE__*/React.cloneElement(child, Object.assign({}, child.props, {
        'data-test-id': dataTestId || 'group-selector',
        children: /*#__PURE__*/jsx(InnerSummary, {
          children: child.props.children,
          customMinHeight: customMinHeight,
          customPadding: customPadding,
          customPaddingWithBottom: customPaddingWithBottom,
          dataTestId: child.props.dataTestId,
          index: _startIndex + index
        })
      }));
    })
  });
};

const StyledImage = styled('img')(({
  isLoaded,
  maxWidth,
  marginAuto
}) => Object.assign({
  display: isLoaded ? 'block' : 'none',
  [maxWidth ? 'maxWidth' : ' width']: '100%'
}, marginAuto && {
  margin: 'auto'
}));
const fallbackFormats = ['svg', 'png'];
const getImageExtention = url => {
  const arr = typeof url === 'string' ? url.split('.') : ['svg'];
  return arr[arr.length - 1];
};
const ImageComponent = ({
  shouldFallback: _shouldFallback = false,
  hideLogoOnLoadFailed: _hideLogoOnLoadFailed = true,
  fallbackSrc,
  src,
  alt,
  className,
  maxWidth: _maxWidth = false,
  marginAuto: _marginAuto = false
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [fallback, setFallback] = useState({
    fallbackSrc,
    isFallbackLoaded: false
  });
  const imgFormat = getImageExtention(src);
  const [logoExtention, setLogoExtention] = useState({
    initilizedExtention: imgFormat,
    extention: null,
    fallbackFormats: fallbackFormats.filter(format => format !== imgFormat)
  });
  const onLoadLogoError = () => {
    if (_shouldFallback) {
      const nextFormat = logoExtention.fallbackFormats[0];
      if (logoExtention.fallbackFormats.length) return setLogoExtention(Object.assign({}, logoExtention, {
        extention: nextFormat,
        fallbackFormats: logoExtention.fallbackFormats.filter(format => format !== nextFormat)
      }));
      if (fallback.fallbackSrc && !fallback.isFallbackLoaded) return setFallback(Object.assign({}, fallback, {
        isFallbackLoaded: true
      }));
    }
    setIsLoaded(!_hideLogoOnLoadFailed);
  };
  const onLoad = () => {
    setIsLoaded(true);
  };
  useEffect(() => {
    setLogoExtention({
      initilizedExtention: imgFormat,
      extention: null,
      fallbackFormats: fallbackFormats.filter(format => format !== imgFormat)
    });
  }, [imgFormat, src, _shouldFallback]);
  return /*#__PURE__*/jsx(StyledImage, {
    alt: alt,
    className: className,
    isLoaded: isLoaded,
    marginAuto: _marginAuto,
    maxWidth: _maxWidth,
    src: fallback.isFallbackLoaded && fallback.fallbackSrc ? fallback.fallbackSrc : src.replace(logoExtention.initilizedExtention, logoExtention.extention || logoExtention.initilizedExtention),
    onError: onLoadLogoError,
    onLoad: onLoad
  });
};

const StyledButtonX = styled$1('button')({
  all: 'unset',
  '&:focus': {
    outline: '-webkit-focus-ring-color auto 1px'
  },
  '&:focus-visible': {
    outline: '-webkit-focus-ring-color auto 1px'
  }
});
const Image = styled$1(ImageComponent)({
  height: '100%',
  width: 'auto',
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain'
});
const StyledHeader = styled$1('header')(({
  theme,
  hideHeaderBorderBottom,
  shouldHideLogo
}) => Object.assign({
  display: 'flex',
  gap: theme.spacing(shouldHideLogo ? 2 : 0),
  position: 'relative',
  alignItems: shouldHideLogo ? 'center' : 'start',
  justifyContent: shouldHideLogo ? 'end' : 'space-between',
  boxSizing: 'border-box',
  padding: theme.spacing(shouldHideLogo ? 3 : 4),
  paddingBottom: theme.spacing(0),
  height: theme.spacing(shouldHideLogo ? 6 : 11),
  ':before': {
    content: '""',
    position: 'absolute',
    left: theme.spacing(3),
    right: theme.spacing(3),
    bottom: 0,
    height: 1
  }
}, hideHeaderBorderBottom || shouldHideLogo ? {} : {
  borderBottom: `1px solid ${theme.palette.grey[200]}`
}));
const Logo = styled$1('div')(({
  theme
}) => ({
  height: '100%',
  maxWidth: theme.spacing(25),
  maxHeight: theme.spacing(5)
}));
const Header = ({
  logo,
  logoAlt,
  onClose,
  endAdornment: _endAdornment = null,
  modalCloseButtonAccessability,
  hideHeaderBorderBottom
}) => {
  const theme = useTheme();
  return /*#__PURE__*/jsxs(StyledHeader, {
    "data-test-id": "header",
    hideHeaderBorderBottom: !!hideHeaderBorderBottom,
    shouldHideLogo: !logo,
    children: [logo && /*#__PURE__*/jsx(Logo, {
      "data-test-id": "modal-header-logo",
      children: typeof logo === 'string' ? /*#__PURE__*/jsx(Image, {
        alt: logoAlt,
        shouldFallback: true,
        src: logo
      }) : logo
    }), !logo && _endAdornment, /*#__PURE__*/jsx(StyledButtonX, {
      "aria-label": modalCloseButtonAccessability,
      "data-test-id": "modal-close-button",
      onClick: onClose,
      children: /*#__PURE__*/jsx(CloseRoundedIcon, {
        sx: {
          cursor: 'pointer',
          color: theme.palette.grey[400]
        }
      })
    }), !!logo && _endAdornment]
  });
};

const iconsInfoMessage = {
  email: /*#__PURE__*/jsx(DraftsIcon, {
    color: "primary",
    fontSize: "small"
  }),
  credit: /*#__PURE__*/jsx(CreditCardIcon, {
    color: "primary",
    fontSize: "small"
  }),
  cart: /*#__PURE__*/jsx(ShoppingCartIcon, {
    color: "primary",
    fontSize: "small"
  }),
  location: /*#__PURE__*/jsx(LocationOnIcon, {
    color: "primary",
    fontSize: "small"
  }),
  leasable: /*#__PURE__*/jsx(CategoryIcon, {
    color: "primary",
    fontSize: "small"
  })
};

const VerticalSpace = styled('div')(({
  theme,
  units: _units = 2
}) => ({
  height: theme.spacing(_units),
  minHeight: theme.spacing(_units),
  maxHeight: theme.spacing(_units)
}));

const StyledInfoContainer$1 = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start'
});
const IconBox = styled('div')(({
  theme
}) => ({
  marginRight: theme.spacing(1),
  svg: {
    marginTop: '2px'
  }
}));
const InfoBox = styled('div')({
  display: 'flex',
  flexFlow: 'column'
});
const Instructions = ({
  title,
  content,
  customIcon,
  titleLogo,
  icon: _icon = 'cart'
}) => {
  return /*#__PURE__*/jsxs(StyledInfoContainer$1, {
    "data-test-id": `instructions-${customIcon ? 'custom' : _icon}`,
    children: [/*#__PURE__*/jsx(IconBox, {
      children: customIcon ? customIcon : iconsInfoMessage[_icon]
    }), /*#__PURE__*/jsxs(InfoBox, {
      children: [/*#__PURE__*/jsxs(Typography, {
        display: "flex",
        position: "relative",
        variant: "h5",
        children: [title, titleLogo]
      }), /*#__PURE__*/jsx(VerticalSpace, {
        units: 1
      }), /*#__PURE__*/jsx(Typography, {
        variant: "body1",
        children: content
      })]
    })]
  });
};

const variants = theme => {
  var _theme$palette$primar;
  return {
    info: {
      color: theme.palette['primary'].dark,
      backgroundColor: (_theme$palette$primar = theme.palette['primary'].lighter) != null ? _theme$palette$primar : theme.palette['primary'].light
    },
    error: {
      color: theme.palette['error'].dark,
      backgroundColor: theme.palette['error'].lighter
    },
    success: {
      color: theme.palette['success'].dark,
      backgroundColor: theme.palette['success'].lighter
    },
    warning: {
      color: theme.palette['warning'].dark,
      backgroundColor: theme.palette['warning'].lighter
    }
  };
};
const Container$3 = styled$1('label')(({
  theme,
  variant: _variant = 'info',
  textAlign
}) => Object.assign({}, theme.typography.body1, {
  fontWeight: 700
}, variants(theme)[_variant], {
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  borderRadius: theme.spacing(0.25),
  textAlign: textAlign != null ? textAlign : 'initial'
}));
const Label = ({
  variant,
  children,
  textAlign
}) => {
  return /*#__PURE__*/jsx(Container$3, {
    "data-test-id": "label",
    textAlign: textAlign,
    variant: variant,
    children: children
  });
};

const animation = keyframes({
  '0%': {
    opacity: 0,
    transform: 'rotate(45deg) translate(5px, 5px)'
  },
  '50%': {
    opacity: 1
  },
  '100%': {
    opacity: 0,
    transform: 'rotate(45deg) translate(12px, 12px)'
  }
});
const Arrow = styled('span')(({
  theme
}) => ({
  display: 'block',
  width: '13px',
  height: '13px',
  borderBottom: `4px solid ${theme.palette.primary.main}`,
  borderRight: `4px solid ${theme.palette.primary.main}`,
  transform: 'rotate(45deg)',
  margin: '-7px',
  animation: `${animation} 2s infinite`
}));
const AnimatedArrow = () => {
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx(Arrow, {
      sx: {
        animationDelay: '-0.1s'
      }
    }), /*#__PURE__*/jsx(Arrow, {
      sx: {
        animationDelay: '-0.3s'
      }
    })]
  });
};
var AnimatedArrow$1 = AnimatedArrow;

const Container$2 = styled$1(ScrollAreaPrimitive.Root)(({
  height: _height = '300px'
}) => ({
  overflow: 'hidden',
  boxSizing: 'border-box',
  height: _height
}));
const ScrollAreaThumb = styled$1(ScrollAreaPrimitive.Thumb)(({
  theme
}) => ({
  borderRadius: '2px',
  backgroundColor: theme.palette.grey[400],
  boxShadow: '0 0 1px hsl(0deg 0% 100% / 50%)',
  WebkitBoxShadow: '0 0 1px hsl(0deg 0% 100% / 50%)',
  flex: 1,
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    minWidth: 44,
    minHeight: 44
  }
}));
const Scrollbar = styled$1(ScrollAreaPrimitive.Scrollbar)(({
  theme,
  size
}) => ({
  display: 'flex',
  userSelect: 'none',
  touchAction: 'none',
  margin: 0,
  MozOutlineRadius: '2px',
  background: theme.palette.grey[200],
  '&[data-orientation="vertical"]': {
    width: size
  },
  '&[data-orientation="horizontal"]': {
    flexDirection: 'column',
    height: size
  }
}));
const StyledViewport = styled$1(ScrollAreaPrimitive.Viewport)({
  width: '100%',
  height: '100%',
  borderRadius: 'inherit'
});
const StyledCorner = styled$1(ScrollAreaPrimitive.Corner)(({
  theme
}) => ({
  background: theme.palette.grey[200]
}));
const ScrollArea = /*#__PURE__*/React.forwardRef(({
  children,
  height: _height2 = '100%',
  onScroll,
  size: _size = '6px',
  type: _type = 'auto'
}, ref) => {
  return /*#__PURE__*/jsxs(Container$2, {
    height: _height2,
    type: _type,
    children: [/*#__PURE__*/jsx(StyledViewport, {
      ref: ref,
      "data-test-id": "scroll-area",
      tabIndex: 0,
      onScroll: onScroll,
      children: children
    }), /*#__PURE__*/jsx(Scrollbar, {
      orientation: "horizontal",
      size: _size,
      children: /*#__PURE__*/jsx(ScrollAreaThumb, {})
    }), /*#__PURE__*/jsx(Scrollbar, {
      orientation: "vertical",
      size: _size,
      children: /*#__PURE__*/jsx(ScrollAreaThumb, {})
    }), /*#__PURE__*/jsx(StyledCorner, {})]
  });
});

const StyledLegalFrame = styled('div')(({
  theme
}) => ({
  postion: 'relative',
  width: '100%',
  border: `2px solid ${theme.palette.grey[200]}`,
  boxSizing: 'border-box'
}));
const StyledRelativeContainer = styled('div')({
  position: 'relative'
});
const StyledScrolledButton = styled('div')(({
  theme
}) => ({
  width: '100%',
  position: 'absolute',
  bottom: 0,
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  borderTop: 'none',
  margin: '0 -1px -1px -1px'
}));
const StyledScrolledButtonText = styled('div')(({
  theme,
  clickable
}) => ({
  padding: theme.spacing(1, 4),
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: clickable ? 'pointer' : 'default'
}));
const StyledScrollImgContainer = styled('div')({
  width: '100%',
  position: 'absolute',
  bottom: 0,
  height: 80,
  background: 'linear-gradient(#FFFFFF00, #FFFFFF)',
  pointerEvents: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
const StyledChildrenContainer = styled('div')(({
  padding,
  theme
}) => ({
  padding: typeof padding === 'number' ? theme.spacing(padding) : padding
}));
const LegalBox = ({
  children,
  scrollListener,
  bannerText: _bannerText = 'Scroll down to proceed',
  innerSpacing: _innerSpacing = 0,
  showScrollBanner: _showScrollBanner = false,
  height: _height = '380px',
  isScrollDownClickable: _isScrollDownClickable = true,
  scrollBannerVariant: _scrollBannerVariant = 'button'
}) => {
  const [displayBanner, setDisplayBanner] = useState(false);
  const [maxHeight, setMaxHeight] = useState(_height);
  const isScrolled = useRef(false);
  const bottomElement = useRef(null);
  const childrenElementRef = useCallback(node => {
    if (!node) return;
    const resizeObserver = new ResizeObserver(() => {
      const contentHeight = typeof _height === 'string' ? Number(_height.split('px')[0]) : _height;
      setDisplayBanner(node.getBoundingClientRect().height > contentHeight && _showScrollBanner && !isScrolled.current);
      if ((node == null ? void 0 : node.getBoundingClientRect().height) <= contentHeight && scrollListener) {
        scrollListener(true);
        setMaxHeight(`${node.getBoundingClientRect().height}px`);
      } else if (scrollListener) {
        scrollListener(isScrolled.current);
        setMaxHeight(`${contentHeight}px`);
      }
    });
    resizeObserver.observe(node);
  }, []);
  const handleScroll = e => {
    const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop <= e.currentTarget.clientHeight + 1;
    if (bottom && scrollListener && !isScrolled.current) {
      isScrolled.current = true;
      scrollListener(true);
      if (displayBanner) {
        setDisplayBanner(false);
      }
    }
  };
  const handleClickScrollToBottom = event => {
    event.preventDefault();
    if (_isScrollDownClickable && bottomElement.current) {
      bottomElement.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return /*#__PURE__*/jsxs(StyledLegalFrame, {
    "data-test-id": "legal-box",
    children: [/*#__PURE__*/jsxs(ScrollArea, {
      height: maxHeight,
      onScroll: handleScroll,
      children: [/*#__PURE__*/jsx(StyledChildrenContainer, {
        padding: _innerSpacing,
        children: /*#__PURE__*/jsx("div", {
          ref: childrenElementRef,
          children: children
        })
      }), /*#__PURE__*/jsx("div", {
        ref: bottomElement
      })]
    }), displayBanner && /*#__PURE__*/jsx(StyledRelativeContainer, {
      children: _scrollBannerVariant === 'button' ? /*#__PURE__*/jsx(StyledScrolledButton, {
        onClick: handleClickScrollToBottom,
        children: /*#__PURE__*/jsxs(StyledScrolledButtonText, {
          clickable: _isScrollDownClickable,
          children: [/*#__PURE__*/jsx(Typography, {
            color: "white",
            fontWeight: 700,
            variant: "h5",
            children: _bannerText
          }), /*#__PURE__*/jsx(ExpandCircleDownOutlinedIcon, {
            sx: {
              color: 'white'
            }
          })]
        })
      }) : /*#__PURE__*/jsx(StyledScrollImgContainer, {
        children: /*#__PURE__*/jsx(AnimatedArrow$1, {})
      })
    })]
  });
};

const _excluded$a = ["className"];
const StyledTooltip = styled$1(_ref => {
  let {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  return /*#__PURE__*/jsx(MuiTooltip, Object.assign({}, props, {
    classes: {
      popper: className
    }
  }));
})({
  maxWidth: 496,
  padding: `0 20px`,
  boxSizing: 'border-box',
  [`&.${tooltipClasses.popper}[data-popper-placement="bottom"]`]: {
    [`& .${tooltipClasses.tooltip}`]: {
      marginTop: 24
    },
    [`& .${tooltipClasses.arrow}`]: {
      top: -18,
      '&::before': {
        boxShadow: '-8px -6px 10px -6px rgb(0 0 0 / 10%)'
      }
    }
  },
  [`&.${tooltipClasses.popper}[data-popper-placement="top"]`]: {
    [`& .${tooltipClasses.tooltip}`]: {
      marginBottom: 24
    },
    [`& .${tooltipClasses.arrow}`]: {
      bottom: -18,
      '&::before': {
        boxShadow: '3px 2px 10px -2px rgb(0 0 0 / 10%)'
      }
    }
  },
  [`& .${tooltipClasses.tooltip}`]: {
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    maxWidth: '100%',
    [`& .${tooltipClasses.arrow}`]: {
      width: 40,
      height: 28
    }
  }
});

/**
 * the container for the logos
 * make sure there is 3 logos on each row
 * and the logos are centered
 */
const Container$1 = styled$1('div')(({
  theme,
  gap,
  flexDirection: _flexDirection = 'row'
}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: _flexDirection,
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(gap),
  alignItems: 'center',
  overflow: 'visible'
}));
const grayScaleFilter = {
  filter: 'grayscale(100%) brightness(70%) contrast(100%)',
  opacity: 0.7
};

/**
 * the Logo Button container
 *
 * @param direct - if true, the logo will be clickable
 * @param disabled - if true, the logo will be grayed out
 */
const LogoContainer = styled$1('button')(({
  theme,
  direct,
  logosLenght
}) => Object.assign({
  all: 'unset',
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(direct ? 1 : 0, 1),
  borderRadius: theme.spacing(0.25),
  '& img, & svg': {
    display: 'block',
    width: logosLenght > 2 ? 123 : '100%',
    height: '100%',
    maxWidth: 148,
    maxHeight: 40
  }
}, !direct && grayScaleFilter, direct && {
  '&:disabled': Object.assign({
    pointerEvents: 'none'
  }, grayScaleFilter, {
    border: `2px solid ${theme.palette.grey[200]}`
  }),
  border: `1px solid transparent`,
  '&:not(:disabled)': {
    boxShadow: '0px 1.88304px 18.3596px 4.23684px rgb(81 69 159 / 9%)',
    '&:hover, &:focus': {
      cursor: 'pointer',
      border: `1px solid ${theme.palette.grey[400]}`
    }
  }
}));
const StyledButtonWrapper = styled$1('span')(({
  logosLength
}) => ({
  width: '100%',
  flex: logosLength > 2 ? 0.333 : 0.5
}));

const LenderLogos = ({
  logos,
  onLogoClick,
  direct: _direct = false,
  tooltipText,
  flexDirection
}) => {
  const gap = logos.length <= 2 ? 4 : 1;
  return /*#__PURE__*/jsx(Container$1, {
    "data-test-id": "lender-logos",
    flexDirection: flexDirection,
    gap: gap,
    children: logos.map((lenderLogo, index) => {
      const {
        lenderId = index + '',
        isClickable = false,
        logo = lenderLogo
      } = lenderLogo && typeof lenderLogo === 'object' && 'lenderId' in lenderLogo && lenderLogo || {};
      const clickable = isClickable && _direct;
      const logoComponent = typeof logo === 'string' ? /*#__PURE__*/jsx("img", {
        alt: "direct-lender-logo-button",
        src: logo
      }) : logo;
      const onClick = clickable && !!onLogoClick ? ev => {
        var _ev$target;
        ev.preventDefault();
        if (((_ev$target = ev.target) == null ? void 0 : _ev$target.tagName) !== 'BUTTON') {
          ev.currentTarget.dispatchEvent(new CustomEvent('custom:lenderLogoClick', {
            bubbles: true
          }));
        }
        onLogoClick(lenderId);
      } : undefined;
      return /*#__PURE__*/jsx(StyledTooltip, {
        arrow: true,
        describeChild: true,
        enterTouchDelay: 0,
        leaveTouchDelay: 500000000,
        placement: "top",
        PopperProps: {
          disablePortal: true
        },
        title: clickable || !_direct ? '' : /*#__PURE__*/jsx(Typography, {
          variant: "body3",
          children: tooltipText
        }),
        children: /*#__PURE__*/jsx(StyledButtonWrapper, {
          logosLength: logos.length,
          children: /*#__PURE__*/jsx(LogoContainer, {
            "data-lender": lenderId,
            "data-test-id": "lender-logo",
            direct: _direct,
            disabled: !clickable,
            logosLenght: logos.length,
            type: "button",
            onClick: onClick,
            children: logoComponent
          })
        })
      }, lenderId);
    })
  });
};

const LoaderAnimation = () => {
  const theme = useTheme();
  return /*#__PURE__*/jsxs("svg", {
    "aria-label": "Loading...",
    height: "200px",
    preserveAspectRatio: "xMidYMid",
    role: "img",
    style: {
      margin: 'auto',
      background: 'rgb(255, 255, 255)',
      display: 'block',
      shapeRendering: 'auto'
    },
    viewBox: "0 0 100 100",
    width: "200px",
    children: [/*#__PURE__*/jsxs("circle", {
      cx: "50",
      cy: "50",
      fill: "none",
      r: "0",
      stroke: theme.palette.primary.main,
      strokeWidth: "2",
      children: [/*#__PURE__*/jsx("animate", {
        attributeName: "r",
        begin: "0s",
        calcMode: "spline",
        dur: "1.4925373134328357s",
        keySplines: "0 0.2 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "0;50"
      }), /*#__PURE__*/jsx("animate", {
        attributeName: "opacity",
        begin: "0s",
        calcMode: "spline",
        dur: "1.4925373134328357s",
        keySplines: "0.2 0 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "1;0"
      })]
    }), /*#__PURE__*/jsxs("circle", {
      cx: "50",
      cy: "50",
      fill: "none",
      r: "0",
      stroke: theme.palette.primary.main,
      strokeWidth: "2",
      children: [/*#__PURE__*/jsx("animate", {
        attributeName: "r",
        begin: "-0.7462686567164178s",
        calcMode: "spline",
        dur: "1.4925373134328357s",
        keySplines: "0 0.2 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "0;50"
      }), /*#__PURE__*/jsx("animate", {
        attributeName: "opacity",
        begin: "-0.7462686567164178s",
        calcMode: "spline",
        dur: "1.4925373134328357s",
        keySplines: "0.2 0 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "1;0"
      })]
    })]
  });
};

const StyledDiv = styled$1('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  minHeight: 520
});
const LoaderContainer = styled$1('div')(({
  height
}) => ({
  height: `${height}px`,
  width: '100%'
}));
const Loader = ({
  height: _height = 200,
  scope: _scope = 'global',
  topContent,
  bottomContent
}) => {
  return /*#__PURE__*/jsxs(StyledDiv, {
    "aria-label": "Loading Started",
    "aria-live": "polite",
    "data-scope": _scope,
    "data-test-id": "loader",
    children: [topContent, /*#__PURE__*/jsx(VerticalSpace, {
      units: 5
    }), /*#__PURE__*/jsx(LoaderContainer, {
      height: _height,
      children: /*#__PURE__*/jsx(LoaderAnimation, {})
    }), /*#__PURE__*/jsx(VerticalSpace, {
      units: 5
    }), bottomContent]
  });
};

var $$7 = _export;
var $includes = arrayIncludes.includes;
var fails$3 = fails$m;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$3(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$7({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

const icons = {
  emailOutline: MailOutlineIcon,
  email: DraftsIcon,
  credit: CreditCardIcon,
  cart: ShoppingCartIcon,
  alarmOn: AlarmOnIcon,
  calendarToday: CalendarTodayIcon,
  payments: PaymentsIcon,
  taskCompleted: TaskAltIcon
};
const iconsColors = ['primary', 'secondary', 'error', 'info', 'success', 'warning'];
const IconWrapper$1 = ({
  variant: _variant = 'cart',
  color: _color = 'primary'
}) => {
  const Icon = icons[_variant];
  const isColorVariant = iconsColors.includes(_color);
  const props = Object.assign({}, !isColorVariant && {
    sx: {
      color: _color
    }
  }, isColorVariant && {
    color: _color
  }, {
    fontSize: 'small'
  });
  return /*#__PURE__*/jsx(Icon, Object.assign({}, props));
};

const StyledInfoContainer = styled$1('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start'
});
const LogoBox = styled$1('div')(({
  theme
}) => ({
  marginRight: theme.spacing(1.5),
  svg: {
    marginTop: '-2px'
  }
}));
const StyledTitle = styled$1('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  svg: {
    marginLeft: '4px'
  }
});
const StyledTextContainer = styled$1('div')({});

const MessageBoxWithIcon = ({
  title,
  content,
  suffixIcon,
  iconVariant,
  iconColor,
  titleProps: _titleProps = {},
  contentProps: _contentProps = {
    variant: 'body1'
  }
}) => {
  const {
    variant = 'h5',
    fontWeight = 700,
    lineHeight = 1
  } = _titleProps;
  const titleSx = Object.assign({}, _titleProps, {
    variant,
    fontWeight,
    lineHeight
  });
  return /*#__PURE__*/jsxs(StyledInfoContainer, {
    "data-test-id": "message-box-with-icon",
    children: [/*#__PURE__*/jsx(LogoBox, {
      children: /*#__PURE__*/jsx(IconWrapper$1, {
        color: iconColor,
        variant: iconVariant
      })
    }), /*#__PURE__*/jsxs(StyledTextContainer, {
      children: [/*#__PURE__*/jsxs(StyledTitle, {
        children: [/*#__PURE__*/jsx(Typography, Object.assign({}, titleSx, {
          children: title
        })), suffixIcon]
      }), /*#__PURE__*/jsx(VerticalSpace, {
        units: 1
      }), /*#__PURE__*/jsx(Typography, Object.assign({}, _contentProps, {
        children: content
      }))]
    })]
  });
};

const FooterContainer = styled('div')(({
  theme,
  ineligibilityType
}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: ineligibilityType ? theme.palette.grey['200'] : theme.palette.primary.lighter,
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 0)
}));
const AccordionFooter = ({
  footerValue,
  ineligibilityType
}) => {
  const theme = useTheme();
  return /*#__PURE__*/jsx(FooterContainer, {
    ineligibilityType: ineligibilityType,
    children: !ineligibilityType ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(CheckCircleIcon, {
        color: "primary"
      }), /*#__PURE__*/jsx(Typography, {
        color: theme.palette.primary.main,
        marginLeft: theme.spacing(1),
        variant: "body3",
        weight: 700,
        children: /*#__PURE__*/jsx(FormattedMessage, {
          defaultMessage: 'Approved for full amount',
          id: 'multi.account.approvedForFullAmount'
        })
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(WarningIcon, {
        sx: {
          color: theme.palette.grey['600']
        }
      }), /*#__PURE__*/jsx(Typography, {
        color: theme.palette.grey['600'],
        marginLeft: theme.spacing(1),
        variant: "body3",
        weight: 700,
        children: ineligibilityType === 'availableLimitExceeded' ? /*#__PURE__*/jsx(FormattedMessage, {
          defaultMessage: 'Cart total Exceeds amount by {footerValue, number, ::currency/USD}',
          id: 'multi.account.exceedsAmountBy',
          values: {
            footerValue
          }
        }) : /*#__PURE__*/jsx(FormattedMessage, {
          defaultMessage: 'Cart total should be higher than {footerValue, number, ::currency/USD}',
          id: 'multi.account.shouldBeHigherThan',
          values: {
            footerValue
          }
        })
      })]
    })
  });
};
const PreApprovedAmountContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column'
}));
const PreApprovedAmount = ({
  offerAmount,
  ineligibilityType
}) => {
  const theme = useTheme();
  return /*#__PURE__*/jsxs(PreApprovedAmountContainer, {
    children: [/*#__PURE__*/jsx(Typography, {
      variant: "body2",
      children: /*#__PURE__*/jsx(FormattedMessage, {
        defaultMessage: 'Pre-Approved Credit Limit',
        id: 'multi.account.offerAmountCaption'
      })
    }), /*#__PURE__*/jsx(Typography, {
      color: ineligibilityType ? theme.palette.grey['600'] : theme.palette.primary.main,
      variant: "h3",
      children: /*#__PURE__*/jsx(FormattedNumber, {
        currency: "USD",
        style: "currency",
        value: offerAmount
      })
    })]
  });
};
const LenderLogo = styled('img')(({
  theme
}) => ({
  height: '32px',
  width: '80px',
  paddingRight: theme.spacing(2)
}));
const MultiAccountSelector = ({
  value,
  onChange,
  showRadioButton: _showRadioButton = false,
  showExpandArrow: _showExpandArrow = true,
  children,
  startIndex
}) => {
  return /*#__PURE__*/jsx(GroupSelector, {
    children: children,
    showExpandArrow: _showExpandArrow,
    showRadioButton: _showRadioButton,
    startIndex: startIndex,
    value: value,
    onChange: onChange
  });
};
const MultiAccountSelectorItem = ({
  offerAmount,
  logoUrl,
  cartMinAmount: _cartMinAmount = 0,
  cartTotal: _cartTotal = 0,
  ineligibilityType,
  children
}) => {
  let footerValue = 0;
  switch (ineligibilityType) {
    case 'availableLimitExceeded':
      footerValue = _cartTotal - offerAmount;
      break;
    case 'cartBelowMinimum':
      footerValue = _cartMinAmount;
      break;
  }
  return /*#__PURE__*/jsx(Summary, {
    children: children,
    bottom: () => /*#__PURE__*/jsx(AccordionFooter, {
      footerValue: footerValue,
      ineligibilityType: ineligibilityType
    }),
    end: () => /*#__PURE__*/jsx(LenderLogo, {
      src: logoUrl
    }),
    start: () => /*#__PURE__*/jsx(PreApprovedAmount, {
      ineligibilityType: ineligibilityType,
      offerAmount: offerAmount
    })
  });
};

var isRegExp$1 = isRegexp;

var $TypeError$6 = TypeError;

var notARegexp = function (it) {
  if (isRegExp$1(it)) {
    throw $TypeError$6("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$7 = wellKnownSymbol$k;

var MATCH$1 = wellKnownSymbol$7('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$6 = _export;
var uncurryThis$4 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$6;
var toString$1 = toString$7;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$4(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$6({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$1(requireObjectCoercible(this)),
      toString$1(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const StyledSelect = styled$1(Select$1)({
  width: '100%',
  paddingRight: 0
});
const InputIconsWrapper = styled$1('div')(() => ({
  display: 'flex',
  marginRight: 20
}));
const Wrapper$1 = ({
  disabled,
  isMultiSelect,
  selectedOptions,
  displayValue,
  label,
  displayVisibility,
  handleChange,
  options,
  isCollection,
  checkboxProps,
  onItemHeightChange,
  displayAsValid
}) => {
  const menuItemRef = useRef(null);
  useEffect(() => {
    if (menuItemRef.current) {
      onItemHeightChange == null ? void 0 : onItemHeightChange(menuItemRef.current.offsetHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSelection = (value, checked) => {
    const dummyEvent = {
      target: {
        value
      }
    };
    handleChange(dummyEvent, checked);
  };
  const optionsValues = options.map(x => (x == null ? void 0 : x.value) || x);
  const diffOfOptionsAndSelected = optionsValues
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  .filter(x => !selectedOptions.includes(x));
  const isSelectAllChecked = diffOfOptionsAndSelected.includes('Select All') && diffOfOptionsAndSelected.length === 1;
  const items = options.map(option => {
    const label = isCollection ? option.label : option;
    const value = isCollection ? option.value : option;
    const disabled = isCollection ? option.disabled : false;
    const isChecked = selectedOptions.some(item => {
      if (Array.isArray(value)) {
        return isEqual(value, item);
      }
      if (value === 'Select All' && isSelectAllChecked) {
        return true;
      }
      return item === value;
    });
    const key = Array.isArray(value) ? value.join(',') : value;
    return isMultiSelect ? /*#__PURE__*/jsxs(MenuItem, {
      value: value,
      children: [/*#__PURE__*/jsx(Checkbox, {
        checked: isChecked,
        displayVisibility: displayVisibility
      }), /*#__PURE__*/jsx(ListItemText, {
        primary: label
      })]
    }, key) : checkboxProps != null && checkboxProps.asMenuItem ? /*#__PURE__*/jsx(MenuItem, {
      ref: menuItemRef,
      divider: true,
      selected: isChecked,
      children: /*#__PURE__*/jsx(Checkbox, {
        fullWidth: true,
        checked: isChecked,
        disabled: disabled,
        displayVisibility: displayVisibility,
        label: label,
        value: value,
        onChange: (_, checked) => handleSelection(value, checked)
      })
    }, key) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Checkbox, {
        checked: isChecked,
        disabled: disabled,
        displayVisibility: displayVisibility,
        label: label,
        value: value,
        onChange: (_, checked) => handleSelection(value, checked)
      }, key), /*#__PURE__*/jsx(Divider$2, {})]
    });
  });
  return isMultiSelect ? /*#__PURE__*/jsx(StyledSelect, {
    multiple: true,
    displayVisibility: displayVisibility,
    input: /*#__PURE__*/jsx(OutlinedInput, {
      endAdornment: /*#__PURE__*/jsx(InputAdornment, {
        position: "end",
        children: displayAsValid && /*#__PURE__*/jsx(InputIconsWrapper, {
          children: /*#__PURE__*/jsx(CheckRoundedIcon, {
            fontSize: 'small',
            color: 'success',
            "aria-hidden": "false"
          })
        })
      }),
      inputProps: {
        style: {
          visibility: disabled ? 'hidden' : 'visible'
        }
      },
      label: label
    }),
    renderValue: () => displayValue.join(', '),
    size: "small",
    value: selectedOptions
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    onChange: handleChange,
    children: items
  }) : /*#__PURE__*/jsx("div", {
    children: items
  });
};

const _excluded$9 = ["label", "options", "onChange", "value", "disabled", "displayAsValid", "variant", "checkboxProps", "onItemHeightChange", "selectAll", "error", "helperText"];
function areOptionsOfTypeCollection(options) {
  return Boolean(options[0] && options[0].value && options[0].label);
}
const MultiSelect = _ref => {
  let {
      label,
      options,
      onChange,
      value,
      disabled,
      displayAsValid,
      variant = 'select',
      checkboxProps,
      onItemHeightChange,
      selectAll,
      error,
      helperText
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  const isMultiSelectVariant = variant === 'select';
  const [selectedOptions, setSelectedOptions] = useState(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Array.isArray(value) ? value : []);
  const isCollection = areOptionsOfTypeCollection(options);
  const optionsWithAll = useMemo(() => {
    if (selectAll) {
      const allOption = isCollection ? {
        label: 'Select All',
        value: 'Select All'
      } : 'Select All';
      return [allOption, ...options];
    }
    return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, selectAll]);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setSelectedOptions(Array.isArray(value) ? value : []);
  }, [value]);
  const handleChange = (event, checked) => {
    const {
      target: {
        value
      }
    } = event;

    // Value serves two purposes:
    // 1. When the select is a select, it is an array of selected values
    // 2. When the select is a checkbox, it is a single selected value of a checkbox.
    if (value === 'Select All' || value != null && value.includes('Select All')) {
      const newSelectedOptionsWithAll = isMultiSelectVariant ? value : checked ? isCollection ?
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      [...options.map(x => x.value)] : [...options] : [];
      setSelectedOptions(newSelectedOptionsWithAll);
      onChange == null ? void 0 : onChange(newSelectedOptionsWithAll);
    } else {
      const newSelectedOptions = isMultiSelectVariant ? value : checked ? [...selectedOptions, value] : selectedOptions.filter(option => !isEqual(option, value));
      setSelectedOptions(newSelectedOptions);
      onChange == null ? void 0 : onChange(newSelectedOptions);
    }
  };
  const displayValue = selectedOptions.map(optionValue => {
    // NOTE: https://github.com/microsoft/TypeScript/issues/44373
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const option = options.find(opt => {
      const value = isCollection ? opt.value : opt;
      return value === optionValue;
    });
    return isCollection && option ? option.label : option;
  });
  return /*#__PURE__*/jsxs(FormControl, Object.assign({
    fullWidth: true,
    "data-test-id": "multi-select",
    disabled: disabled,
    error: error
  }, rest, {
    children: [label && isMultiSelectVariant && /*#__PURE__*/jsx(InputLabel, {
      children: label
    }), /*#__PURE__*/jsx(Wrapper$1, {
      checkboxProps: checkboxProps,
      disabled: disabled,
      displayAsValid: displayAsValid,
      displayValue: displayValue,
      displayVisibility: "block",
      handleChange: handleChange,
      isCollection: isCollection,
      isMultiSelect: isMultiSelectVariant,
      label: label
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      ,
      options: optionsWithAll,
      selectedOptions: selectedOptions,
      onItemHeightChange: onItemHeightChange
    }), error && /*#__PURE__*/jsx(FormHelperText, {
      error: error,
      children: /*#__PURE__*/jsx(ErrorText, {
        helperText: helperText
      })
    })]
  }));
};

const StyledTypography = styled(Typography)(() => ({
  fontSize: '14px',
  textDecoration: 'underline',
  textTransform: 'capitalize'
}));
const StyledPaper = styled(Paper)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  borderTop: '1px solid #ECEEEF',
  height: 48,
  paddingLeft: 15,
  paddingRight: 15,
  alignItems: 'center'
}));
const StyledButton$1 = styled(Button)(() => ({
  width: 'fit-content',
  height: 'fit-content'
}));
const ControlFiltersButtons = ({
  onClearClick,
  onSelectAllClick
}) => {
  return /*#__PURE__*/jsxs(StyledPaper, {
    elevation: 0,
    children: [/*#__PURE__*/jsx(StyledButton$1, {
      size: "small",
      variant: "text",
      onClick: onSelectAllClick,
      children: /*#__PURE__*/jsx(StyledTypography, {
        color: "primary",
        weight: 700,
        children: "Select all"
      })
    }), /*#__PURE__*/jsx(StyledButton$1, {
      size: "small",
      variant: "text",
      onClick: onClearClick,
      children: /*#__PURE__*/jsx(StyledTypography, {
        color: "primary",
        weight: 700,
        children: "Clear"
      })
    })]
  });
};

const filterOptions = (options, value) => {
  return options.filter(item => item.toLowerCase().includes(value.toLowerCase()));
};
const filterOptionsByLable = (options, value) => {
  return options.filter(item => item.label.toLowerCase().includes(value.toLowerCase()));
};

const ITEM_HEIGHT = 47;
const StyledTextField = styled$1(TextField)(() => ({
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  }
}));
const MultiSelectWithSearch = ({
  options,
  onChange,
  itemsToShow: _itemsToShow = 4,
  selected,
  placeholder: _placeholder = 'Search'
}) => {
  const [value, setValue] = React.useState('');
  const [height, setItemHeight] = React.useState(ITEM_HEIGHT);
  const isCollection = areOptionsOfTypeCollection(options);
  const [selectedOptions, setSelectedOptions] = React.useState(selected != null ? selected : []);
  const handleCheckboxChange = value => {
    setSelectedOptions(value);
  };
  const handleChange = event => {
    const value = event.target.value;
    setValue(value);
  };
  const filteredOptions = React.useMemo(() => {
    return isCollection ? filterOptionsByLable(options, value) : filterOptions(options, value);
  }, [options, value, isCollection]);
  const handleClearClick = () => {
    setSelectedOptions([]);
  };
  const handleSelectAllClick = () => {
    const newSelectedOptions = isCollection ? filteredOptions.map(option => option.value) : filteredOptions;
    setSelectedOptions(newSelectedOptions);
  };
  const maxHeight = filteredOptions.length > _itemsToShow ? height * _itemsToShow : height * filteredOptions.length;
  React.useEffect(() => {
    onChange(selectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);
  return /*#__PURE__*/jsxs("div", {
    "data-test-id": "multi-select-with-search",
    children: [/*#__PURE__*/jsx(StyledTextField, {
      icon: "search",
      placeholder: _placeholder,
      size: "small",
      value: value,
      onChange: handleChange
    }), /*#__PURE__*/jsx(ScrollArea, {
      height: maxHeight,
      children: /*#__PURE__*/jsx(MultiSelect, {
        checkboxProps: {
          asMenuItem: true
        },
        options: filteredOptions,
        value: selectedOptions,
        variant: "checkbox",
        onChange: handleCheckboxChange,
        onItemHeightChange: itemHeight => setItemHeight(itemHeight)
      })
    }), /*#__PURE__*/jsx(ControlFiltersButtons, {
      onClearClick: handleClearClick,
      onSelectAllClick: handleSelectAllClick
    })]
  });
};

const _excluded$8 = ["inputRef", "onChange"];
const NumberField = props => {
  const {
      inputRef,
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$8);
  return /*#__PURE__*/jsx(NumberFormat, Object.assign({}, other, {
    allowNegative: false,
    autoComplete: "off",
    customInput: TextField,
    "data-test-id": "number-field",
    inputRef: inputRef,
    onValueChange: values => {
      onChange == null ? void 0 : onChange({
        target: {
          value: values.value
        }
      });
    }
  }));
};

const StyledOfferContainer = styled('div')(({
  theme
}) => ({
  minHeight: theme.spacing(12),
  position: 'relative',
  border: `2px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius
}));
const StyledOfferCard = styled('div')(({
  theme,
  hasBottom: _hasBottom = false
}) => Object.assign({
  padding: _hasBottom ? theme.spacing(3, 3, 8) : theme.spacing(3),
  display: 'flex',
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  justifyContent: 'space-between',
  alignItems: 'center'
}, !_hasBottom && {
  borderBottom: `2px solid ${theme.palette.grey[200]}`
}));
const StyledOfferTitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start'
});
const StyleOfferDetails = styled('div')(({
  theme
}) => ({
  padding: theme.spacing(3),
  position: 'relative'
}));
const StyledBottom = styled('div')(({
  theme
}) => ({
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: '100%',
  borderBottom: `2px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  '& > div:first-child': {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius
  }
}));
const OfferCard = ({
  title,
  label,
  caption,
  bottom,
  ariaName: _ariaName = 'offer-card',
  'data-test-id': dataTestId = 'offer-card',
  children
}) => {
  return /*#__PURE__*/jsxs(StyledOfferContainer, {
    "aria-label": _ariaName,
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/jsxs(StyledOfferCard, {
      hasBottom: !!bottom,
      children: [/*#__PURE__*/jsxs(StyledOfferTitleContainer, {
        children: [/*#__PURE__*/jsx(Typography, {
          color: "text.primary",
          component: "div",
          variant: "money",
          children: title
        }), /*#__PURE__*/jsx(Typography, {
          component: "div",
          variant: "body1",
          children: caption
        })]
      }), /*#__PURE__*/jsx(Label, {
        children: label
      }), bottom && /*#__PURE__*/jsx(StyledBottom, {
        children: bottom
      })]
    }), /*#__PURE__*/jsx(StyleOfferDetails, {
      "aria-label": `${_ariaName}-details`,
      "data-test-id": `${dataTestId}-details`,
      children: children
    })]
  });
};

const Circle = props => {
  const theme = useTheme();
  return /*#__PURE__*/jsxs(SvgIcon, Object.assign({
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    fill: 'none',
    sx: {
      width: 26,
      height: 26,
      fill: 'none'
    }
  }, props, {
    children: [/*#__PURE__*/jsxs("g", {
      clipPath: "url(#clip0_4256_22769)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "14.2178",
        cy: "13.5487",
        fill: theme.palette.primary.dark,
        r: "11.6132"
      }), /*#__PURE__*/jsx("circle", {
        cx: "12.2823",
        cy: "11.6132",
        fill: theme.palette.primary.main,
        r: "11.6132"
      }), /*#__PURE__*/jsx("path", {
        d: "M12.2823 21.2908C17.6271 21.2908 21.9599 16.958 21.9599 11.6132C21.9599 6.26835 17.6271 1.93552 12.2823 1.93552C6.93745 1.93552 2.60461 6.26835 2.60461 11.6132C2.60461 16.958 6.93745 21.2908 12.2823 21.2908Z",
        stroke: "white",
        "stroke-miterlimit": "10",
        "stroke-width": "0.91287"
      })]
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("clipPath", {
        id: "clip0_4256_22769",
        children: /*#__PURE__*/jsx("rect", {
          fill: "white",
          height: "26",
          width: "26"
        })
      })
    })]
  }));
};

const StyledList = styled('ol')(({
  theme,
  listIndent: _listIndent = 4
}) => ({
  listStyle: 'none',
  counterReset: 'num',
  paddingLeft: theme.spacing(_listIndent)
}));
const StyledListItem = styled('li')(({
  theme,
  listItemGutters: _listItemGutters = 4,
  verticalAlign: _verticalAlign = '3px'
}) => ({
  counterIncrement: 'num',
  paddingTop: _verticalAlign,
  paddingBottom: '8px',
  paddingLeft: '2.2rem',
  marginBottom: theme.spacing(_listItemGutters),
  position: 'relative',
  '&:before': {
    content: 'counter(num)',
    position: 'absolute',
    top: '0.2rem',
    left: '8.5px',
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 900,
    fontFamily: theme.typography.fontFamily,
    color: '#fff',
    zIndex: 10
  },
  '&:last-child': {
    marginBottom: 0
  }
}));
const IconWrapper = styled(Circle)({
  position: 'absolute',
  left: 0,
  top: 0
});

/**
 *
 * @description - OrderedList component, used to display a list of items with a CA bullet. Do not use this component with more than 9 items.
 * @param listItems - pass an array of strings or ReactNodes, it'll be sorted by index
 * @param listIndent - indent of the list, default is 4 (32px). Increments of 8px
 * @param listItemGutters - space between list items, default is 4 (32px). Increments of 8px
 * @param verticalAlign - vertical alignment of the list item and the bullet, default is 3px
 */
const OrderedList = ({
  listItems,
  listIndent: _listIndent2 = 4,
  listItemGutters: _listItemGutters2 = 4,
  verticalAlign: _verticalAlign2 = '3px'
}) => {
  return /*#__PURE__*/jsx(StyledList, {
    "data-test-id": "ca-ordered-list",
    listIndent: _listIndent2,
    children: listItems == null ? void 0 : listItems.map((item, index) => /*#__PURE__*/jsxs(StyledListItem, {
      "data-test-id": `ca-ordered-list-item-${index + 1}`,
      listItemGutters: _listItemGutters2,
      verticalAlign: _verticalAlign2,
      children: [/*#__PURE__*/jsx(IconWrapper, {}), item]
    }, index))
  });
};

const StyledFlexTitle = styled$1('div')(({
  justify
}) => ({
  display: 'flex',
  flexFlow: 'column',
  alignItems: justify
}));
const TitleContainer = styled$1('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start'
});
const PageTitleSection = ({
  title,
  subtitle,
  children,
  prefixIcon,
  justify: _justify = 'flex-start',
  titleTypography: _titleTypography = {
    variant: 'h3'
  },
  subtitleTypography: _subtitleTypography = {
    variant: 'body1'
  }
}) => {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(!!title || !!subtitle) && /*#__PURE__*/jsxs(StyledFlexTitle, {
      justify: _justify,
      children: [!!title && /*#__PURE__*/jsxs(TitleContainer, {
        children: [prefixIcon ? prefixIcon : null, /*#__PURE__*/jsx(Typography, Object.assign({
          "data-test-id": "title"
        }, _titleTypography, {
          children: title
        }))]
      }), !!subtitle && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(VerticalSpace, {
          units: 1
        }), /*#__PURE__*/jsx(Typography, Object.assign({
          "data-test-id": "subtitle"
        }, _subtitleTypography, {
          children: subtitle
        }))]
      })]
    }), children]
  });
};

const Container = styled$1('div')(({
  theme,
  shape,
  elevation: _elevation = 0,
  onlyTopBorder
}) => ({
  border: onlyTopBorder ? `2px solid transparent` : `2px solid ${theme.palette.grey[200]}`,
  borderTop: `2px solid ${theme.palette.grey[200]}`,
  borderRadius: `${shape === 'round' ? '4px' : shape === 'arch' ? '4px 4px 2px 2px' : '0'}`,
  position: 'relative',
  boxShadow: onlyTopBorder ? 'none' : theme.shadows[_elevation]
}));
const UpperStrip = styled$1('div')(({
  theme
}) => Object.assign({}, theme.typography.body1, {
  background: 'white',
  lineHeight: '1.25rem',
  fontWeight: 500,
  color: theme.palette.grey[400],
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: theme.spacing(0, 1),
  whiteSpace: 'nowrap'
}));
const Content = styled$1('div')(({
  theme,
  onlyTopBorder
}) => ({
  padding: onlyTopBorder ? theme.spacing(2, 0) : theme.spacing(2)
}));
const Panel = ({
  title,
  icon,
  children,
  isFullyRounded: _isFullyRounded = false,
  shape: _shape = 'arch',
  elevation: _elevation2 = 0,
  bottomContent,
  onlyTopBorder: _onlyTopBorder = false
}) => {
  const titleComponent = title && typeof title === 'string' ? /*#__PURE__*/jsx(Typography, {
    variant: "body1",
    children: title
  }) : title ? title : icon ? icon : null;
  return /*#__PURE__*/jsxs(Container, {
    "data-test-id": "panel",
    elevation: _elevation2,
    onlyTopBorder: _onlyTopBorder,
    shape: _isFullyRounded ? 'round' : _shape,
    children: [!!titleComponent && /*#__PURE__*/jsx(UpperStrip, {
      children: titleComponent
    }), /*#__PURE__*/jsx(Content, {
      onlyTopBorder: _onlyTopBorder,
      children: children
    }), bottomContent]
  });
};

const StyledDrawer = styled$1(Drawer)(({
  theme
}) => ({
  zIndex: 1,
  '& .MuiDrawer-paper': {
    padding: 0,
    paddingTop: theme.spacing(4),
    position: 'absolute',
    //imp
    marginTop: 'auto',
    borderRadius: '20px 20px 0px 0px',
    boxSizing: 'border-box',
    overflowY: 'visible',
    flex: 0,
    maxHeight: 'calc(100% - 40px)'
  }
}));
const StyledBoxContainer = styled$1(Box)(({
  open,
  theme
}) => ({
  zIndex: 1,
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  pointerEvents: open ? 'all' : 'none',
  '&::before': {
    backgroundColor: 'black',
    content: "''",
    opacity: open ? 0.2 : 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}));
const StyledSvgButton = styled$1(IconButton)({
  position: 'absolute',
  width: 38,
  height: 38,
  top: -16,
  borderRadius: '50%',
  left: 'calc(50% - 19px)',
  backgroundColor: '#fff',
  '&:hover': {
    backgroundColor: '#fff'
  }
});
const StyledContentBox = styled$1(Box)(({
  theme
}) => ({
  overflow: 'hidden',
  overflowY: 'auto',
  padding: theme.spacing(4),
  paddingTop: 0
}));

const CloseButton = /*#__PURE__*/forwardRef(({
  onClick,
  customCloseButton
}, ref) => {
  return /*#__PURE__*/jsx(StyledSvgButton, {
    ref: ref,
    "aria-label": "close information",
    color: "primary",
    size: "small",
    onClick: onClick,
    children: customCloseButton || /*#__PURE__*/jsx(MenuIcon, {})
  });
});
const Popover = ({
  children,
  open,
  onClose: onCloseEvent,
  customCloseButton
}) => {
  const boxRef = useRef(null);
  const buttonRef = useRef(null);
  const onClose = () => {
    onCloseEvent == null ? void 0 : onCloseEvent();
  };
  return /*#__PURE__*/jsx(StyledBoxContainer, {
    ref: boxRef,
    open: open,
    children: /*#__PURE__*/jsx(Unstable_TrapFocus, {
      disableRestoreFocus: true,
      open: open,
      children: /*#__PURE__*/jsxs(StyledDrawer, {
        anchor: "bottom",
        container: boxRef.current,
        "data-test-id": "drawer",
        open: open,
        SlideProps: {
          mountOnEnter: true,
          unmountOnExit: true
        },
        variant: "persistent",
        onClose: onClose,
        children: [/*#__PURE__*/jsx(CloseButton, {
          ref: buttonRef,
          customCloseButton: customCloseButton,
          onClick: onClose
        }), /*#__PURE__*/jsx(StyledContentBox, {
          children: children
        })]
      })
    })
  });
};

const _excluded$7 = ["options", "onChange", "value", "error", "helperText", "touched", "width"];
const RadioButtons = _ref => {
  let {
      options,
      onChange,
      value,
      error,
      helperText,
      width = 'fit-content'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  const memoizedOptions = useMemo(() => {
    return options.map(option => {
      var _currOption$value;
      const currOption = typeof option === 'string' ? {
        value: option,
        label: option
      } : option;
      return /*#__PURE__*/jsx(FormControlLabel, Object.assign({
        checked: (value == null ? void 0 : value.toString()) === ((_currOption$value = currOption.value) == null ? void 0 : _currOption$value.toString()),
        control: /*#__PURE__*/jsx(Radio, Object.assign({}, rest))
      }, currOption), currOption.label);
    });
  }, [options, value]);
  return /*#__PURE__*/jsx(FormControl, {
    sx: {
      width: width
    },
    children: /*#__PURE__*/jsxs(RadioGroup, {
      onChange: onChange,
      children: [memoizedOptions, error && helperText && /*#__PURE__*/jsx(FormHelperText, {
        error: error,
        children: /*#__PURE__*/jsx(ErrorText, {
          helperText: helperText
        })
      })]
    })
  });
};

const ScreenContainer = styled$1('div')(({
  theme
}) => ({
  maxWidth: 520,
  boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.331069);`,
  borderRadius: 5,
  padding: theme.spacing(4)
}));

const Select = ({
  options,
  onChange,
  selected,
  width: _width = '100%',
  renderInput,
  customListItem,
  label,
  disabled,
  valid,
  error,
  helperText,
  placeholder,
  dataTestId,
  updateMenuPositionOnResize
}) => {
  const menuAction = useRef(null);
  const handleChange = e => {
    onChange(e.target.value);
  };
  const handleOpen = () => {
    if (updateMenuPositionOnResize) {
      setTimeout(() => {
        var _menuAction$current;
        (_menuAction$current = menuAction.current) == null ? void 0 : _menuAction$current.updatePosition();
      }, 500);
    }
  };
  const memoizedOptions = useMemo(() => {
    return options.map(option => typeof option === 'string' ? {
      value: option,
      label: option
    } : option);
  }, [options]);
  const testId = !!dataTestId && '-' + dataTestId || '';
  return /*#__PURE__*/jsxs(FormControl, {
    "data-test-id": `select-form-control${testId}`,
    error: error,
    sx: {
      width: _width
    },
    children: [label && /*#__PURE__*/jsx(InputLabel
    //MARK: Not in theme because this input label is not part of select,
    //don't know how its override will affect display in other places
    , {
      sx: {
        '&.MuiInputLabel-outlined:not(.Mui-focused, .MuiInputLabel-shrink)': {
          transform: 'translate(14px, 8.5px) scale(1)'
        }
      },
      children: label
    }), /*#__PURE__*/jsx(Select$1, {
      autoComplete: "off",
      "data-test-id": `select${testId}`,
      disabled: disabled,
      displayEmpty: !!placeholder,
      endAdornment: !!valid && /*#__PURE__*/jsx(InputAdornment, {
        position: 'start',
        sx: {
          pointerEvents: 'none',
          cursor: 'default',
          position: 'absolute',
          right: 26
        },
        children: /*#__PURE__*/jsx(CheckRoundedIcon, {
          fontSize: 'small',
          color: 'success',
          "aria-hidden": "false",
          "aria-label": `${label} valid`,
          "aria-live": "polite"
        })
      }),
      IconComponent: KeyboardArrowDownRoundedIcon,
      label: label,
      MenuProps: {
        action: menuAction
      },
      placeholder: placeholder,
      renderValue: selected => {
        var _memoizedOptions$find;
        return renderInput != null ? renderInput : ((_memoizedOptions$find = memoizedOptions.find(option => option.value === selected)) == null ? void 0 : _memoizedOptions$find.label) || placeholder;
      },
      value: typeof selected === 'string' ? selected : selected == null ? void 0 : selected.value,
      onChange: handleChange,
      onOpen: handleOpen,
      children: memoizedOptions.map(({
        value,
        label
      }) => {
        var _customListItem;
        return /*#__PURE__*/jsx(MenuItem, {
          "data-test-id": `select-item-${value}`,
          value: value,
          children: (_customListItem = customListItem == null ? void 0 : customListItem(label, typeof selected === 'string' ? value === selected : value === (selected == null ? void 0 : selected.value))) != null ? _customListItem : label
        }, value);
      })
    }), !!helperText && /*#__PURE__*/jsx(FormHelperText, {
      children: helperText
    })]
  });
};

const _excluded$6 = ["message", "action", "customContent"];
const Snackbar = _ref => {
  let {
      message,
      action,
      customContent
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  const commonProps = {
    'data-test-id': 'snackbar'
  };
  const content = customContent ? /*#__PURE__*/jsx("div", Object.assign({}, commonProps, {
    children: customContent
  })) : /*#__PURE__*/jsx(SnackbarContent, Object.assign({}, commonProps, {
    action: action,
    message: message
  }));
  return /*#__PURE__*/jsx(Snackbar$1, Object.assign({}, rest, {
    children: content
  }));
};

const UnCompleteIcon = styled$1('div')(({
  theme,
  active
}) => Object.assign({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: theme.palette.grey[300]
}, active && {
  backgroundColor: theme.palette.primary.main
}));
const StepperIcon = ({
  complete: _complete4 = true,
  active,
  title
}) => {
  const theme = useTheme();
  if (!_complete4) {
    return /*#__PURE__*/jsx(UnCompleteIcon, {
      active: active,
      "aria-label": title
    });
  }
  return /*#__PURE__*/jsx(SvgIcon, {
    "aria-label": title,
    fill: "none",
    height: "7",
    style: {
      width: 8,
      height: 7,
      padding: 2,
      transform: 'scale(2)'
    },
    viewBox: "0 0 8 7",
    width: "8",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M2.85612 5.05268L1.605 3.66103C1.46559 3.50596 1.24397 3.50596 1.10456 3.66103C0.965147 3.8161 0.965147 4.06262 1.10456 4.21769L2.60232 5.8837C2.74173 6.03877 2.96694 6.03877 3.10635 5.8837L6.89544 1.67296C7.03485 1.51789 7.03485 1.27137 6.89544 1.1163C6.75603 0.961233 6.53441 0.961233 6.395 1.1163L2.85612 5.05268Z",
      fill: theme.palette.primary.main,
      stroke: theme.palette.primary.main
    })
  });
};

const Connector = styled$1(StepConnector)(({
  theme
}) => ({
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderWidth: 1,
    borderColor: theme.palette.grey[300]
  }
}));
const stepIcon = ({
  completed,
  icon,
  active
}) => {
  const completedState = completed ? 'completed' : 'empty';
  return StepperIcon({
    active,
    complete: !!completed,
    title: `charge-after-${icon}-${completedState}`
  });
};
const BaseStep = styled$1(Step)(() => ({
  '& .MuiStepLabel-iconContainer': {
    paddingLeft: 0,
    paddingRight: 0
  }
}));
const Stepper = ({
  activeStep
}) => {
  return /*#__PURE__*/jsxs(Stepper$1, {
    activeStep: activeStep,
    connector: /*#__PURE__*/jsx(Connector, {}),
    "data-test-id": "stepper",
    children: [/*#__PURE__*/jsx(BaseStep, {
      children: /*#__PURE__*/jsx(StepLabel, {
        StepIconComponent: stepIcon
      })
    }), /*#__PURE__*/jsx(BaseStep, {
      children: /*#__PURE__*/jsx(StepLabel, {
        StepIconComponent: stepIcon
      })
    }), /*#__PURE__*/jsx(BaseStep, {
      children: /*#__PURE__*/jsx(StepLabel, {
        StepIconComponent: stepIcon
      })
    })]
  });
};

const Switch = styled(props => /*#__PURE__*/jsx(MuiSwitch, Object.assign({
  disableRipple: true,
  "data-test-id": "switch",
  focusVisibleClassName: ".Mui-focusVisible"
}, props)))(({
  theme
}) => ({
  width: 42,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 1,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        borderColor: '#426BEC',
        backgroundColor: '#C9D6FF',
        opacity: 1
      },
      '& .MuiSwitch-thumb': {
        border: '6px solid #426BEC',
        color: '#426BEC'
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '.MuiSwitch-thumb': {
      border: '6px solid #65686D',
      color: '#65686D'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18
  },
  '& .MuiSwitch-track': {
    border: '2px solid #65686D',
    borderRadius: 26 / 2,
    backgroundColor: '#ECEEEF',
    opacity: 1,
    height: 'unset',
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

const ToggleButton = ({
  value,
  onChange,
  options,
  descriptionId,
  disabled
}) => {
  return /*#__PURE__*/jsx(ToggleButtonGroup, {
    exclusive: true,
    fullWidth: true,
    "aria-describedby": descriptionId,
    color: 'primary',
    disabled: disabled,
    value: value,
    onChange: onChange,
    children: options.map(({
      value,
      label
    }) => /*#__PURE__*/jsx(ToggleButton$1, {
      value: value,
      children: label
    }, value))
  });
};

const StyledAccordion = styled$1(Accordion$1)(({
  theme
}) => ({
  border: `${theme.spacing(0.125)} solid ${theme.palette.grey[400]}`,
  borderRadius: theme.spacing(1),
  boxSizing: 'border-box',
  '&.Mui-disabled': {
    backgroundColor: 'white'
  },
  '&::before': {
    display: 'none'
  }
}));
const StyledCheckIcon = styled$1(CheckRoundedIcon)(({
  theme
}) => ({
  color: theme.palette.success.main,
  fontSize: '1.5rem',
  height: 'auto',
  marginLeft: theme.spacing(1)
}));
const StyledAccordionSummary = styled$1(AccordionSummary$1)(({
  theme
}) => {
  return {
    borderRadius: theme.spacing(1),
    '&.Mui-expanded': {
      minHeight: theme.spacing(6),
      borderRadius: theme.spacing(1, 1, 0, 0)
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      color: theme.palette.grey[600]
    },
    '& .MuiAccordionSummary-content': Object.assign({}, theme.typography.h25, {
      color: theme.palette.grey[600],
      fontSize: '1rem'
    }),
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      color: theme.palette.grey[800]
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: theme.spacing(1.5, 0),
      color: theme.palette.grey[800]
    },
    '&.Mui-focusVisible': {
      background: theme.palette.primary.lighter
    }
  };
});
const StyledAccordionDetails = styled$1(AccordionDetails)(({
  contentEventsDisabled
}) => ({
  '& .MuiFormControlLabel-root': {
    pointerEvents: contentEventsDisabled ? 'none' : 'all'
  }
}));
const StyledButton = styled$1(Button)(({
  theme
}) => {
  const buttonHoveActiveFocusStyle = {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
    outlineColor: theme.palette.primary.dark,
    outlineWidth: 2,
    outlineOffset: -1,
    outlineStyle: 'solid',
    border: 'none',
    borderTop: `1px solid white`,
    boxShadow: `none`
  };
  const defaultButtonStyle = {
    border: 'none',
    background: theme.palette.primary.lighter,
    borderTop: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    boxShadow: `none`
  };
  return Object.assign({}, defaultButtonStyle, {
    borderRadius: theme.spacing(0.85),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxSizing: 'border-box',
    '& .MuiTouchRipple-child': {
      color: theme.palette.primary.main,
      boxShadow: `none`
    },
    '&:hover': buttonHoveActiveFocusStyle,
    '&:active, &:focus': defaultButtonStyle,
    '&:focus-visible': buttonHoveActiveFocusStyle
  });
});
const StyledAccordionActions = styled$1(AccordionActions)({
  padding: 0
});

const StyledArrow = styled$1(ArrowBack)({
  transform: 'rotate(-90deg)',
  transformOrigin: '50%'
});
const ExpandIcon = () => {
  return /*#__PURE__*/jsx(StyledArrow, {
    fontSize: "small"
  });
};

const AccordionSummary = ({
  shouldHaveFocus,
  accordionFocusTabIndex,
  text,
  showCheckMark
}) => /*#__PURE__*/jsxs(StyledAccordionSummary, {
  "aria-controls": "accordion-panel-content",
  expandIcon: /*#__PURE__*/jsx(ExpandIcon, {}),
  id: "accordion-panel-header"
  // don't ask why but seems like there is a bug with it on the styled/sx way which keeps the pointer cursor
  // and no Matan there is no !important or overrides not for hover and not by someone else
  ,
  style: {
    cursor: shouldHaveFocus ? 'pointer' : 'initial'
  },
  tabIndex: accordionFocusTabIndex,
  children: [text, showCheckMark && /*#__PURE__*/jsx(StyledCheckIcon, {
    "aria-hidden": "false",
    "aria-live": "polite"
  })]
});

const Accordion = ({
  children,
  actionsRender,
  summaryProps,
  expanded,
  disabled,
  onChange,
  controlVariant: _controlVariant = 'default',
  shouldHaveFocus: _shouldHaveFocus = true,
  contentEventsDisabled: _contentEventsDisabled = false
}) => {
  const [isOpen, setIsOpen] = useState(expanded || false);
  const accordionOnChange = _controlVariant === 'default' || _controlVariant === 'order' && !expanded && _shouldHaveFocus ? onChange : undefined;
  const renderActionsOnChange = _controlVariant === 'order' ? onChange : undefined;
  const accordionFocusTabIndex = _controlVariant === 'order' && !_shouldHaveFocus ? -1 : 0;
  const isExpanded = expanded !== undefined ? expanded : isOpen;
  const onChangeExpanded = (event, open) => {
    setIsOpen(open);
    accordionOnChange == null ? void 0 : accordionOnChange(event, open);
  };
  return /*#__PURE__*/jsxs(StyledAccordion, Object.assign({
    square: true,
    disabled: disabled,
    elevation: 0,
    onChange: onChangeExpanded
  }, expanded === undefined && {
    expanded: isOpen
  }, expanded !== undefined && {
    expanded,
    onChange: accordionOnChange
  }, {
    children: [/*#__PURE__*/jsx(AccordionSummary, Object.assign({}, summaryProps, {
      accordionFocusTabIndex: accordionFocusTabIndex,
      shouldHaveFocus: _shouldHaveFocus
    })), /*#__PURE__*/jsx(StyledAccordionDetails, {
      contentEventsDisabled: _contentEventsDisabled,
      children: children
    }), actionsRender && /*#__PURE__*/jsx(StyledAccordionActions, {
      children: actionsRender({
        onChange: renderActionsOnChange,
        expanded: isExpanded
      })
    })]
  }));
};

var getBuiltIn$3 = getBuiltIn$7;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var wellKnownSymbol$6 = wellKnownSymbol$k;
var DESCRIPTORS$1 = descriptors;

var SPECIES$2 = wellKnownSymbol$6('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$2]) {
    defineBuiltInAccessor(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$2 = objectIsPrototypeOf;

var $TypeError$5 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw $TypeError$5('Incorrect invocation');
};

var uncurryThis$3 = functionUncurryThis;
var fails$2 = fails$m;
var isCallable$5 = isCallable$p;
var classof$1 = classof$7;
var getBuiltIn$2 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop$2 = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$2('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$3(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop$2);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  try {
    construct(noop$2, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor = isConstructor$1;
var tryToString$2 = tryToString$4;

var $TypeError$4 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$4(tryToString$2(argument) + ' is not a constructor');
};

var anObject$4 = anObject$e;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$6;
var wellKnownSymbol$5 = wellKnownSymbol$k;

var SPECIES$1 = wellKnownSymbol$5('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$4(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$4(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
};

var uncurryThis$2 = functionUncurryThisClause;
var aCallable$5 = aCallable$9;
var NATIVE_BIND = functionBindNative;

var bind$4 = uncurryThis$2(uncurryThis$2.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$5(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$1 = functionUncurryThis;

var arraySlice$1 = uncurryThis$1([].slice);

var $TypeError$3 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw $TypeError$3('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$6 = global$l;
var apply = functionApply;
var bind$3 = functionBindContext;
var isCallable$4 = isCallable$p;
var hasOwn$1 = hasOwnProperty_1;
var fails$1 = fails$m;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$6.setImmediate;
var clear = global$6.clearImmediate;
var process$3 = global$6.process;
var Dispatch = global$6.Dispatch;
var Function$1 = global$6.Function;
var MessageChannel = global$6.MessageChannel;
var String$1 = global$6.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$1(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$6.location;
});

var run = function (id) {
  if (hasOwn$1(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$6.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$4(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$6.addEventListener &&
    isCallable$4(global$6.postMessage) &&
    !global$6.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$1(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$6.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$1 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$5 = global$l;
var bind$2 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
var document$2 = global$5.document;
var process$2 = global$5.process;
var Promise$1 = global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$5, 'queueMicrotask');
var microtask$1 = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$2.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$2(macrotask, global$5);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$4 = global$l;

var promiseNativeConstructor = global$4.Promise;

/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$3 = global$l;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$3 = isCallable$p;
var isForced$1 = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$4 = wellKnownSymbol$k;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$4('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$3(global$3.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced$1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$4 = aCallable$9;

var $TypeError$2 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$2('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$4(resolve);
  this.reject = aCallable$4(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$5 = _export;
var IS_NODE = engineIsNode;
var global$2 = global$l;
var call$6 = functionCall;
var defineBuiltIn$2 = defineBuiltIn$8;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var setSpecies$1 = setSpecies$2;
var aCallable$3 = aCallable$9;
var isCallable$2 = isCallable$p;
var isObject$2 = isObject$a;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process$1 = global$2.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && isCallable$2(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$6(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$2['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$6(task, global$2, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$6(task, global$2, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$6(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$3(executor);
    call$6(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$2(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$2(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process$1.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$2(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$2(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$6(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$1) {
      setPrototypeOf$1(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$5({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies$1(PROMISE);

var wellKnownSymbol$3 = wellKnownSymbol$k;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$3('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var classof = classof$7;
var getMethod$1 = getMethod$5;
var isNullOrUndefined = isNullOrUndefined$6;
var Iterators = iterators;
var wellKnownSymbol$2 = wellKnownSymbol$k;

var ITERATOR$1 = wellKnownSymbol$2('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof(it)];
};

var call$5 = functionCall;
var aCallable$2 = aCallable$9;
var anObject$3 = anObject$e;
var tryToString$1 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$1 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$2(iteratorMethod)) return anObject$3(call$5(iteratorMethod, argument));
  throw $TypeError$1(tryToString$1(argument) + ' is not iterable');
};

var call$4 = functionCall;
var anObject$2 = anObject$e;
var getMethod = getMethod$5;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$2(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$4(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$2(innerResult);
  return value;
};

var bind = functionBindContext;
var call$3 = functionCall;
var anObject$1 = anObject$e;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$3;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$1(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$3(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$1 = wellKnownSymbol$k;

var ITERATOR = wellKnownSymbol$1('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$4 = _export;
var call$2 = functionCall;
var aCallable$1 = aCallable$9;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$4({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$2($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$3 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable$1 = isCallable$p;
var defineBuiltIn$1 = defineBuiltIn$8;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$3({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$1(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$1(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$2 = _export;
var call$1 = functionCall;
var aCallable = aCallable$9;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$2({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call$1($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$1 = _export;
var call = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$1({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject = anObject$e;
var isObject$1 = isObject$a;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $ = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

const useExpandedDefaultIndex = children => useMemo(() => {
  let defaultExpandedIndex = null;
  Children.toArray(children).some((child, index) => {
    const childCast = child;
    if (childCast.props.defaultExpanded) {
      defaultExpandedIndex = index;
      return true;
    }
    return false;
  });
  return defaultExpandedIndex;
}, [children]);

const useGroupAccordionChildrens = ({
  children,
  controlVariant,
  expandedIndex,
  setExpandedIndex
}) => useMemo(() => {
  const childrenLength = Children.toArray(children).length;
  return Children.map(children, (child, index) => {
    if ( /*#__PURE__*/isValidElement(child)) {
      const isExpanded = expandedIndex === index;
      const shouldHaveFocus = controlVariant === 'default' || controlVariant === 'order' && expandedIndex === null && index === 0;
      const onChange = (event, expanded) => {
        let newExpandedIndex = null;
        if (controlVariant === 'default') {
          newExpandedIndex = expanded ? index : null;
        } else {
          newExpandedIndex = expandedIndex === null ? 0 : isExpanded && !expanded && childrenLength > index + 1 ? expandedIndex + 1 : null;
        }
        setExpandedIndex(newExpandedIndex);
      };
      return /*#__PURE__*/cloneElement(child, {
        expanded: isExpanded,
        onChange,
        controlVariant,
        shouldHaveFocus
      });
    }
    return child;
  });
}, [children, controlVariant, expandedIndex, setExpandedIndex]);

const _excluded$5 = ["children"];
const StyledGroup = styled$1('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  '& .MuiAccordion-root.Mui-expanded': {
    margin: theme.spacing(1, 0)
  }
}));
const AccordionGroup = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  const expandedDefaultIndex = useExpandedDefaultIndex(children);
  const [expandedIndex, setExpandedIndex] = useState(expandedDefaultIndex);
  const clonedChildren = useGroupAccordionChildrens(Object.assign({}, props, {
    children,
    expandedIndex,
    setExpandedIndex
  }));
  return /*#__PURE__*/jsx(StyledGroup, {
    children: clonedChildren
  });
};

const Title = styled(Typography)(({
  theme
}) => Object.assign({}, theme.typography.money, {
  color: theme.palette.text.primary
}));
const Caption = styled(Typography)(({
  theme
}) => Object.assign({}, theme.typography.body1));
const KeyValue = ({
  label,
  value
}) => /*#__PURE__*/jsxs("div", {
  style: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  children: [/*#__PURE__*/jsx(Typography, {
    variant: "body2",
    children: label
  }), /*#__PURE__*/jsx(Typography, {
    variant: "body2",
    weight: 700,
    children: value
  })]
});
const AccordionSelector = ({
  value,
  dataTestId,
  onChange,
  showRadioButton: _showRadioButton = false,
  showExpandArrow: _showExpandArrow = true,
  children,
  startIndex,
  customMinHeight,
  customPadding,
  customPaddingWithBottom
}) => {
  return /*#__PURE__*/jsx(GroupSelector, {
    children: children,
    customMinHeight: customMinHeight,
    customPadding: customPadding,
    customPaddingWithBottom: customPaddingWithBottom,
    dataTestId: dataTestId != null ? dataTestId : 'accordion-selector',
    showExpandArrow: _showExpandArrow,
    showRadioButton: _showRadioButton,
    startIndex: startIndex,
    value: value,
    onChange: onChange
  });
};
const AccordionSelectorItem = ({
  title,
  dataTestId,
  caption,
  label,
  end,
  children,
  bottom
}) => {
  return /*#__PURE__*/jsx(Summary, {
    children: children,
    bottom: bottom,
    "data-test-id": dataTestId != null ? dataTestId : 'accordion-selector-item',
    end: end ? end : label ? () => /*#__PURE__*/jsx(Label, {
      textAlign: "center",
      children: label
    }) : undefined,
    start: () => /*#__PURE__*/jsxs("div", {
      children: [typeof title === 'string' ? /*#__PURE__*/jsx(Title, {
        children: title
      }) : title, typeof caption === 'string' ? /*#__PURE__*/jsx(Caption, {
        children: caption
      }) : caption]
    })
  });
};
const Details = ({
  value,
  index,
  children
}) => {
  return value === index ? /*#__PURE__*/jsx(AccordionDetails, {
    "data-test-id": `accordion-details-${index}`,
    children: children
  }) : null;
};

const useSecretField = ({
  onFocus: onFocusProp,
  onBlur: onBlurProp,
  inputType,
  inputRef
}) => {
  const intl = useIntl();
  const inputTypeRef = useRef(inputType || 'text');
  const dateInputFormat = getInputFormat(intl);
  const onFocus = event => {
    onFocusProp == null ? void 0 : onFocusProp(event);
    if (inputRef && inputRef.current && inputTypeRef.current) {
      inputRef.current.type = inputTypeRef.current;
    }
  };
  const onBlur = event => {
    onBlurProp == null ? void 0 : onBlurProp(event);
    if (inputRef && inputRef.current) {
      inputRef.current.type = 'password';
    }
  };
  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.type = 'password';
    }
  }, [inputRef]);
  return {
    onFocus,
    onBlur,
    dateInputFormat
  };
};

const _excluded$4 = ["label", "onFocus", "onBlur", "onChange", "textFieldProps"],
  _excluded2 = ["dateInputFormat"];
/**
 * DateField component
 * this is the V6 Mui Date Field component
 *
 * see {@link DateFieldProps}
 */
const DateField = _ref => {
  let {
      label,
      onFocus,
      onBlur,
      onChange,
      textFieldProps
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  const inputRef = useRef(null);
  const _useSecretField = useSecretField({
      onFocus,
      onBlur,
      inputType: 'text',
      inputRef
    }),
    {
      dateInputFormat
    } = _useSecretField,
    inputProps = _objectWithoutPropertiesLoose(_useSecretField, _excluded2);
  return /*#__PURE__*/jsx(DateField$1, Object.assign({}, rest, {
    'data-test-id': 'date-picker-input',
    fullWidth: true,
    format: dateInputFormat,
    inputRef: inputRef,
    label: label,
    size: "small",
    slotProps: {
      textField: Object.assign({}, textFieldProps, inputProps)
    },
    slots: {
      textField: TextField
    },
    onChange: onChange
  }));
};

const StyledDivider = styled$1(Divider$2)(({
  theme,
  thickness: _thickness = 2,
  margin: _margin = 0
}) => ({
  border: `${_thickness}px solid ${theme.palette.grey[200]}`,
  borderBottomWidth: 'thin',
  margin: theme.spacing(_margin, 0)
}));
const Divider = ({
  thickness,
  margin
}) => {
  return /*#__PURE__*/jsx(StyledDivider, {
    margin: margin,
    thickness: thickness
  });
};

var isCallable = isCallable$p;
var isObject = isObject$a;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var defineProperty = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var DESCRIPTORS = descriptors;
var global$1 = global$l;
var uncurryThis = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty = createNonEnumerableProperty$6;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isPrototypeOf = objectIsPrototypeOf;
var isRegExp = isRegexp;
var toString = toString$7;
var getRegExpFlags = regexpGetFlags;
var stickyHelpers = regexpStickyHelpers;
var proxyAccessor = proxyAccessor$1;
var defineBuiltIn = defineBuiltIn$8;
var fails = fails$m;
var hasOwn = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$2;
var wellKnownSymbol = wellKnownSymbol$k;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global$1.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global$1.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global$1, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

/**
 *
 * @param value - value to be masked
 * @param numberOfLastDigits - number of digits to be visible at the end of the string
 * @param replacer - replacer character for the masked chars
 * @returns masked string
 *
 * @example
 * lastDigitMaskingFormatting('1234567890') // ******7890
 * lastDigitMaskingFormatting('1234567890', 3) // *********890
 * lastDigitMaskingFormatting('1234567890', 3, 'X') // XXXXXXX890
 * lastDigitMaskingFormatting('(123) 456-7890', 3,) // (XXX) XXX-X890
 */
const lastDigitMaskingFormatting = (value, numberOfLastDigits = 4, replacer = '*') => {
  return value.replace(new RegExp(`[a-zA-Z0-9](?=(?:\\W*[a-zA-Z0-9]){${numberOfLastDigits}})`, 'gm'), replacer);
};

/**
 *
 * @param mask - mask to be used
 * @param shouldShowPlaceholder - should show placeholder
 * @param shouldBeHidden - should be hidden
 * @param maskPlaceholder - mask placeholder, default is '_'
 * @returns MaskOpts object
 *
 * @example
 * getMaskOpts({ mask: '(000) 000-0000' }) // returns { mask: '(000) 000-0000', definitions: { '*': { mask: '0', displayChar: '*' } }, placeholderChar: undefined, lazy: true }
 * getMaskOpts({ mask:'(000) 000-0000', shouldBeHidden: true }) // returns { mask: '(***) ***-0000', definitions: { '*': { mask: '0', displayChar: '*' } }, placeholderChar: undefined, lazy: true }
 * getMaskOpts({ mask:'(000) 000-0000', shouldShowPlaceholder: true }) // returns { mask: '(000) 000-0000', definitions: { '*': { mask: '0', displayChar: '*' } }, placeholderChar: undefined, lazy: false }
 */
const getMaskOpts$1 = ({
  mask,
  shouldShowPlaceholder: _shouldShowPlaceholder = false,
  shouldBeHidden: _shouldBeHidden = false,
  maskPlaceholder
}) => {
  return {
    mask: _shouldBeHidden ? lastDigitMaskingFormatting(mask) : mask,
    definitions: {
      '*': {
        mask: '0',
        displayChar: '*'
      }
    },
    placeholderChar: maskPlaceholder,
    lazy: !(_shouldShowPlaceholder && maskPlaceholder),
    overwrite: false
  };
};

const _excluded$3 = ["mask", "shouldBeHidden", "maskPlaceholder", "onChange", "unmask", "inputRef", "value", "defaultValue"];
const noop$1 = () => void 0;
const MobileFieldMasked = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      mask,
      shouldBeHidden = false,
      maskPlaceholder,
      onChange,
      unmask = true,
      value: parentValue = '',
      defaultValue = parentValue
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  const focusRef = useRef(false);
  const [opts, setOpts] = useState(getMaskOpts$1({
    mask,
    shouldShowPlaceholder: !!defaultValue,
    maskPlaceholder,
    shouldBeHidden
  }));

  // 'accept' event fired on input when mask value has changed
  const onAccept = value => {
    var _maskRef$current$unma, _maskRef$current;
    onChange == null ? void 0 : onChange(!unmask ? value : (_maskRef$current$unma = (_maskRef$current = maskRef.current) == null ? void 0 : _maskRef$current.unmaskedValue) != null ? _maskRef$current$unma : '');
  };
  const {
    ref: maskInputRef,
    maskRef,
    value,
    unmaskedValue
  } = useIMask(opts, {
    onAccept
  });

  // on focus we want to show the field as it is
  const onFocus = e => {
    focusRef.current = true;
    setOpts(getMaskOpts$1({
      mask,
      maskPlaceholder,
      shouldShowPlaceholder: true
    }));
    rest.onFocus == null ? void 0 : rest.onFocus(e);
  };

  // on blur we want to mask with secret the field
  const onBlur = e => {
    var _maskRef$current2;
    focusRef.current = false;
    setOpts(getMaskOpts$1({
      mask,
      maskPlaceholder,
      shouldBeHidden,
      shouldShowPlaceholder: !!((_maskRef$current2 = maskRef.current) != null && _maskRef$current2.unmaskedValue)
    }));
    rest.onBlur == null ? void 0 : rest.onBlur(e);
  };
  useLayoutEffect(() => {
    var _maskRef$current3;
    (_maskRef$current3 = maskRef.current) == null ? void 0 : _maskRef$current3.updateControl();
  });
  useEffect(() => {
    var _maskRef$current4;
    if (maskRef.current && defaultValue) {
      maskRef.current.value = defaultValue;
    }
    (_maskRef$current4 = maskRef.current) == null ? void 0 : _maskRef$current4.updateControl();
  }, [defaultValue, maskRef]);

  // updating the opts of the mask when the props are changing
  useEffect(() => {
    var _maskRef$current5;
    setOpts(getMaskOpts$1({
      mask,
      shouldShowPlaceholder: !!((_maskRef$current5 = maskRef.current) != null && _maskRef$current5.unmaskedValue),
      maskPlaceholder,
      shouldBeHidden
    }));
  }, [mask, maskPlaceholder, maskRef, shouldBeHidden, rest.disabled]);

  // updating the input ref of parent
  useEffect(() => {
    if (ref) {
      if (typeof ref === 'function') {
        ref(maskInputRef.current);
      } else {
        ref.current = maskInputRef.current;
      }
    }
  }, [maskInputRef, ref]);
  return (
    /*#__PURE__*/
    // the text field require value field but once we send it the mask start to freakout
    // so we send the value to the maskRef and not to the text field
    // the mask ref uses the inputRef to update the value
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    jsx(TextField, Object.assign({}, rest, {
      inputProps: Object.assign({}, rest.inputProps, {
        value: !value && !unmaskedValue ? defaultValue : !unmaskedValue ? '' : value
      }),
      inputRef: maskInputRef,
      onBlur: onBlur,
      onChange: noop$1,
      onFocus: onFocus
    }))
  );
});

const _excluded$2 = ["inputRef", "onChange", "format", "placeholder", "variant"];
const defaultFormat = '(###) ###-####';
const defaultPlaceholder = '(___) ___-____';
const MobileField = props => {
  const {
      inputRef,
      onChange,
      format = defaultFormat,
      placeholder = defaultPlaceholder,
      variant = 'unmasked'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$2);
  const baseProps = Object.assign({
    'data-test-id': 'mobile-field'
  }, other, {
    autoComplete: 'off',
    inputRef
  });
  const maskFormat = useMemo(() => (typeof format === 'function' ? format(other.value) : format).replace(/#/g, '0'), [format, other.value]);
  const onChangeInterceptor = value => {
    onChange == null ? void 0 : onChange({
      target: {
        value
      }
    });
  };
  return variant === 'masked' ? /*#__PURE__*/jsx(MobileFieldMasked, Object.assign({}, baseProps, {
    ref: inputRef,
    mask: maskFormat,
    shouldBeHidden: true,
    onChange: onChangeInterceptor
  })) : /*#__PURE__*/jsx(NumberFormat, Object.assign({}, baseProps, {
    customInput: TextField,
    format: format,
    mask: '_',
    placeholder: placeholder,
    onValueChange: values => {
      onChangeInterceptor(values.value);
    }
  }));
};

const StyledContent = styled$1('div')({
  flex: 1
});
const StyledDialogContent = styled$1(DialogContent)(({
  theme,
  shouldUseNewStepperDesign,
  landscape
}) => Object.assign({
  padding: theme.spacing(shouldUseNewStepperDesign ? 2 : 3, 4),
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3)
  }
}, landscape && {
  // NOTE: not sure if they will want it so left it here in case they will ask for it
  // '&::-webkit-scrollbar': {
  //   WebkitAppearance: 'none',
  //   width: 8,
  //   height: 8,
  //   backgroundColor: '#e4e4e4',
  //   borderRadius: 5,
  // },
  // '&::-webkit-scrollbar-thumb': {
  //   borderRadius: 5,
  //   backgroundColor: '#879196',
  //   WebkitBoxShadow: '0 0 1px hsl(0deg 0% 100% / 50%)',
  // },
}));
const StyledDialogTitle = styled$1(DialogTitle)(({
  theme
}) => ({
  padding: theme.spacing(4),
  paddingBottom: theme.spacing(0),
  boxSizing: 'border-box'
}));
const StyledDialog = styled$1(Dialog)(({
  theme,
  landscape
}) => {
  const modalBaseProps = landscape ? {
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    margin: 0,
    flexDirection: 'row'
  } : {
    maxWidth: 520,
    borderRadius: 5,
    boxShadow: '0px 4px 10px 0px #00000054'
  };
  return {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0,0,0,0.3)'
    },
    '& .MuiPaper-root.MuiDialog-paper': Object.assign({}, modalBaseProps, {
      width: '100%',
      overflowY: 'hidden',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'initial',
        maxHeight: '100%',
        margin: 0,
        borderRadius: 0,
        height: '100%'
      }
    }),
    [`& ${StyledDialogTitle} + ${StyledDialogContent}`]: {
      paddingTop: theme.spacing(4)
    }
  };
});
const StyledLeftContent = styled$1('div')(({
  theme,
  shouldUseNewStepperDesign,
  shouldHideLogo
}) => ({
  backgroundColor: '#FAFAFA',
  flex: 0.25,
  padding: theme.spacing(shouldHideLogo ? 6 : 11, 4, shouldUseNewStepperDesign ? 2 : 3)
}));
const StyledRightContent = styled$1('div')({
  flex: 0.75,
  display: 'flex',
  flexDirection: 'column'
});

const BaseContent = props => {
  const {
    children,
    shouldShowHeader,
    shouldShowFooter,
    customFooterText,
    alertComponent,
    accessability,
    landscape
  } = props;
  const shouldUseNewStepperDesign = !!shouldShowHeader && !!props.headerProps.hideHeaderBorderBottom;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!!shouldShowHeader && /*#__PURE__*/jsx(Header, Object.assign({}, props.headerProps, {
      logoAlt: accessability.modalMerchantLogo,
      modalCloseButtonAccessability: accessability.modalCloseButton,
      onClose: props.onClickClose
    })), alertComponent, /*#__PURE__*/jsxs(StyledDialogContent, {
      landscape: !!landscape,
      shouldUseNewStepperDesign: shouldUseNewStepperDesign,
      children: [/*#__PURE__*/jsx(StyledContent, {
        children: children
      }), /*#__PURE__*/jsx(VerticalSpace, {
        units: 3
      }), !!shouldShowFooter && /*#__PURE__*/jsx(Footer, {
        text: customFooterText
      })]
    })]
  });
};
const InStore = props => {
  const {
    shouldShowHeader,
    stepper
  } = props;
  const shouldUseNewStepperDesign = !!shouldShowHeader && !!props.headerProps.hideHeaderBorderBottom;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(StyledLeftContent, {
      shouldHideLogo: !!shouldShowHeader && !props.headerProps.logo,
      shouldUseNewStepperDesign: shouldUseNewStepperDesign,
      children: stepper
    }), /*#__PURE__*/jsx(StyledRightContent, {
      children: /*#__PURE__*/jsx(BaseContent, Object.assign({}, props))
    })]
  });
};
const Modal = props => {
  const {
    open,
    accessability,
    systemBannerPlaceholder,
    landscape = false
  } = props;
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  return /*#__PURE__*/jsxs(StyledDialog, {
    "data-test-id": "modal"
    // **disableEscapeKeyDown true** prevents event swallowing by modal,
    // we need it to be propogated for accessibility reasons, like hiding tooltip on "Esc"
    ,
    disableEscapeKeyDown: true,
    landscape: landscape,
    open: open,
    PaperProps: {
      'aria-label': accessability.modalDescription,
      'aria-labelledby': undefined
    },
    scroll: isSmall || landscape ? 'paper' : 'body',
    children: [systemBannerPlaceholder, landscape ? /*#__PURE__*/jsx(InStore, Object.assign({}, props)) : /*#__PURE__*/jsx(BaseContent, Object.assign({}, props))]
  });
};

const Wrapper = styled$1('div')(({
  theme,
  wrapperType: _wrapperType = 'shadow'
}) => ({
  padding: theme.spacing(3, 2, 3, 3),
  borderRadius: 4,
  boxShadow: _wrapperType === 'shadow' ? '0px 2px 10px rgba(0, 0, 0, 0.1)' : 'unset',
  border: _wrapperType === 'border' ? `2px solid ${theme.palette.grey[300]}` : 'unset'
}));
const ContentContainer = styled$1('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start'
}));
const PersonalInfo = styled$1('div')(() => ({
  flex: 1,
  overflow: 'hidden'
}));
const PersonalInfoRow = styled$1(Typography)(({
  theme
}) => ({
  color: theme.palette.grey['600'],
  '&:not(:last-child)': {
    marginBottom: 3
  },
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
}));
const EditButton = styled$1(Button)(({
  theme
}) => ({
  textTransform: 'none',
  marginTop: -10,
  marginRight: -16,
  '& > span': {
    marginRight: 4,
    marginLeft: -2,
    marginTop: -2
  },
  '&:focus': {
    outline: `2px solid ${theme.palette.primary.main}`
  }
}));
const PersonalInfoSummaryContent = ({
  data,
  onEditClick,
  editInfoLabel
}) => {
  return /*#__PURE__*/jsxs(ContentContainer, {
    "data-test-id": "personal-info-overview",
    children: [/*#__PURE__*/jsx(PersonalInfo, {
      children: data.map(dataRow => /*#__PURE__*/jsx(PersonalInfoRow, {
        className: "fs-mask",
        variant: "body2",
        children: dataRow
      }, dataRow))
    }), /*#__PURE__*/jsx(EditButton, {
      icon: "edit",
      size: "small",
      variant: "textWithIcon",
      onClick: onEditClick,
      children: editInfoLabel != null ? editInfoLabel : 'Edit Info'
    })]
  });
};
const PersonalInfoSummary = props => {
  return /*#__PURE__*/jsx(Wrapper, {
    wrapperType: props.wrapperType,
    children: /*#__PURE__*/jsx(PersonalInfoSummaryContent, Object.assign({}, props))
  });
};

const _excluded$1 = ["shouldValidateFromChildren", "renderChildren", "buttonText", "inputProps", "onAgreed"];
const RemoteDisclosure = props => {
  var _inputProps$checked;
  const _ref = props,
    {
      shouldValidateFromChildren = false,
      renderChildren,
      buttonText,
      inputProps,
      onAgreed
    } = _ref,
    accordionProps = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  const [valid, setValid] = useState(false);
  // the checked is the accordion check while the above checked is for inner checkboxes that control the accordion ability to be checked or not
  // e.g like prerequisite for the accordion to be checked
  const [agreed, setAgreed] = useState((_inputProps$checked = inputProps == null ? void 0 : inputProps.checked) != null ? _inputProps$checked : false);
  const actionsRender = useCallback(({
    onChange,
    expanded
  }) => {
    const onClick = event => {
      if (expanded) {
        onChange == null ? void 0 : onChange(event, false);
        setAgreed(true);
        inputProps == null || inputProps.onChange == null ? void 0 : inputProps.onChange({
          // this is due to the fact we use some custom component with input capability for checkbox
          // while keeping it hidden from the user
          target: {
            value: true,
            checked: true
          }
        });
        onAgreed == null ? void 0 : onAgreed();
      }
    };
    return /*#__PURE__*/jsx(StyledButton, {
      fullWidth: true,
      className: "test",
      "data-test-id": "remote-disclosure-button",
      disabled: shouldValidateFromChildren && !valid,
      name: accordionProps.name,
      size: "small",
      onClick: onClick,
      children: buttonText
    });
  }, [shouldValidateFromChildren, valid, accordionProps.name, buttonText, inputProps, onAgreed]);
  const children = renderChildren == null ? void 0 : renderChildren({
    valid,
    setValid
  });
  return /*#__PURE__*/jsxs(Accordion, Object.assign({}, accordionProps, {
    actionsRender: actionsRender,
    children: [/*#__PURE__*/jsx("input", Object.assign({
      checked: agreed
      // this is just to remove React warning, we get onChange from inputProps for forms capability
      ,
      onChange: () => void 0
    }, inputProps, {
      type: "hidden"
    })), children]
  }));
};

const getNumberOfCharsInMask = mask => {
  // calculate how much number or letter in string excluding all symbols
  const maskWithoutSymbols = mask.replace(/[^\w]/gi, '');
  return maskWithoutSymbols.length;
};

const onDispatch = (appended, dynamicMasked, tail) => {
  const isChunkExist = typeof tail === 'object' ? 'chunks' in tail : false;
  if ((!tail || !isChunkExist) && !appended) {
    return dynamicMasked.currentMask;
  }

  /**
   * Tail is an object with chunks property that contains an array of objects with value property.
   *
   * when cursor is not at the end if the value every thing after the cursor is tail
   * imask split to chunks based on mask e.g
   *
   * (000) 000-0000
   *
   * for example the input value is
   *
   * (123) 5
   *
   * if i add a 6 after 1 then
   * chunks will be [{value:'23'},{value:'5'}]
   * and the value in the mask will be (16
   *
   * if i add 7 before 5
   * chunks will be [{value:'5'}]
   */
  const tailCharsCount = typeof tail === 'object' && 'chunks' in tail ? tail.chunks.reduce((acc, curr) => {
    return acc + curr.value.length;
  }, 0) : 0;
  const numberOfCharsInValue = `${dynamicMasked.unmaskedValue}${appended}`.length + tailCharsCount;
  return dynamicMasked.compiledMasks.find(m => {
    const currMask = m;
    return currMask.numberOfCharsToMask === numberOfCharsInValue - 1;
  });
};

/**
 *
 * @param mask - mask to be used
 * @param shouldShowPlaceholder - should show placeholder
 * @param maskPlaceholder - mask placeholder, default is '_'
 * @returns MaskOpts Array
 */
const getMaskOpts = ({
  mask,
  shouldShowPlaceholder: _shouldShowPlaceholder = false,
  maskPlaceholder,
  maskAll: _maskAll = false
}) => {
  const baseOptArgs = {
    overwrite: false,
    definitions: {
      '*': {
        mask: '0',
        displayChar: '*'
      }
    }
  };
  const charsLength = getNumberOfCharsInMask(mask);
  const maskArgs = [];
  for (let i = 0; i <= charsLength; i++) {
    maskArgs.push(Object.assign({}, baseOptArgs, {
      mask: lastDigitMaskingFormatting(mask, _maskAll ? 0 : charsLength - i),
      numberOfCharsToMask: i,
      placeholderChar: maskPlaceholder,
      lazy: !(_shouldShowPlaceholder && maskPlaceholder)
    }));
  }
  return {
    mask: maskArgs,
    overwrite: false,
    dispatch: onDispatch
  };
};

const _excluded = ["mask", "shouldBeHidden", "maskPlaceholder", "onChange", "onFocus", "onBlur", "unmask", "inputRef", "value", "defaultValue"];
const noop = () => void 0;
const SecretMaskingField = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _maskRef$current4, _maskRef$current5;
  let {
      mask: incomeMask,
      shouldBeHidden = false,
      maskPlaceholder,
      onChange,
      onFocus,
      onBlur,
      unmask = true,
      value: parentValue = '',
      defaultValue = parentValue
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const mask = useMemo(() => incomeMask.replace(/9/g, '0'), [incomeMask]);
  const [isFocused, setIsFocused] = useState(false);
  const [opts, setOpts] = useState(getMaskOpts({
    mask,
    shouldShowPlaceholder: !!defaultValue,
    maskPlaceholder,
    maskAll: true
  }));

  // 'accept' event fired on input when mask value has changed
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onAccept = (value, maskingRef) => {
    var _maskingRef$unmaskedV;
    onChange == null ? void 0 : onChange(!unmask ? value : (_maskingRef$unmaskedV = maskingRef == null ? void 0 : maskingRef.unmaskedValue) != null ? _maskingRef$unmaskedV : '');
  };
  const {
    ref: maskInputRef,
    maskRef
  } = useIMask(opts, {
    onAccept
  });
  useLayoutEffect(() => {
    var _maskRef$current;
    (_maskRef$current = maskRef.current) == null ? void 0 : _maskRef$current.updateControl();
  });
  useEffect(() => {
    setOpts(getMaskOpts({
      mask,
      shouldShowPlaceholder: !!defaultValue,
      maskPlaceholder,
      maskAll: !isFocused
    }));
  }, [defaultValue, isFocused, mask, maskPlaceholder]);
  useEffect(() => {
    var _maskRef$current2;
    if (maskRef.current && defaultValue) {
      maskRef.current.value = defaultValue;
    }
    (_maskRef$current2 = maskRef.current) == null ? void 0 : _maskRef$current2.updateControl();
  }, [defaultValue, maskRef]);

  // updating the opts of the mask when the props are changing
  useEffect(() => {
    var _maskRef$current3;
    setOpts(getMaskOpts({
      mask,
      shouldShowPlaceholder: !!((_maskRef$current3 = maskRef.current) != null && _maskRef$current3.unmaskedValue),
      maskPlaceholder,
      maskAll: !isFocused
    }));
  }, [mask, maskPlaceholder, maskRef, shouldBeHidden, rest.disabled, isFocused]);

  // updating the input ref of parent
  useEffect(() => {
    if (ref) {
      if (typeof ref === 'function') {
        ref(maskInputRef.current);
      } else {
        ref.current = maskInputRef.current;
      }
    }
  }, [maskInputRef, ref]);
  const handleBlur = e => {
    setOpts(getMaskOpts({
      mask,
      shouldShowPlaceholder: !!defaultValue,
      maskPlaceholder,
      maskAll: true
    }));
    setIsFocused(false);
    onBlur == null ? void 0 : onBlur(e);
  };
  const handleFocus = e => {
    setOpts(getMaskOpts({
      mask,
      shouldShowPlaceholder: !!defaultValue,
      maskPlaceholder,
      maskAll: false
    }));
    setIsFocused(true);
    onFocus == null ? void 0 : onFocus(e);
  };
  return (
    /*#__PURE__*/
    // the text field require value field but once we send it the mask start to freakout
    // so we send the value to the maskRef and not to the text field
    // the mask ref uses the inputRef to update the value
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    jsx(TextField, Object.assign({}, rest, {
      defaultValue: defaultValue,
      InputLabelProps: Object.assign({}, rest.InputLabelProps, ((_maskRef$current4 = maskRef.current) == null ? void 0 : _maskRef$current4.unmaskedValue) && {
        shrink: !!((_maskRef$current5 = maskRef.current) != null && _maskRef$current5.unmaskedValue)
      }),
      inputRef: maskInputRef,
      onBlur: handleBlur,
      onChange: noop,
      onFocus: handleFocus
    }))
  );
});

const GuardIcon = ({
  stroke
}) => {
  const theme = useTheme();
  const iconStroke = stroke || theme.palette.primary.main;
  return /*#__PURE__*/jsxs("svg", {
    fill: "none",
    height: "20",
    viewBox: "0 0 19 20",
    width: "19",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("path", {
      d: "M12.3 2.35L8.7 1L1.5 3.7V10.9C1.95 14.05 4.38 17.2 8.7 19C12.3 17.65 15.45 14.5 15.9 10.9V9.55",
      stroke: iconStroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }), /*#__PURE__*/jsx("path", {
      d: "M6 9.09999L8.7 11.8L17.7 2.79999",
      stroke: iconStroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    })]
  });
};

const LocalizationProviderWrapper = ({
  children
}) => {
  return /*#__PURE__*/jsx(LocalizationProvider, {
    dateAdapter: AdapterDateFns,
    children: /*#__PURE__*/jsx(LocalizationProvider$1, {
      dateAdapter: AdapterDateFns$1,
      children: children
    })
  });
};

export { Accordion, AccordionGroup, AccordionSelector, AccordionSelectorItem, Alert, Autocomplete, Blockquote, BoxSelection, Button, Checkbox, CreditCardCvcField, CreditCardExpiryDatePickerField, CreditCardExpiryField, CreditCardPanField, CurrencyField$1 as CurrencyField, DateField, DatePicker, DeclineMessages, Details, DirectSession, Divider, ErrorText, FicoScore, Footer, GroupSelector, Summary as GroupSelectorItem, GuardIcon, Header, ImageComponent, Instructions, KeyValue, Label, LegalBox, LenderLogos, Loader, LocalizationProviderWrapper as LocalizationProvider, MaskedTextField, MessageBoxWithIcon, MobileField, Modal, MultiAccountSelector, MultiAccountSelectorItem, MultiSelect, MultiSelectWithSearch, NumberField, OfferCard, OrderedList, PageTitleSection, Panel, PersonalInfoSummary, Popover, Radio, RadioButtons, RemoteDisclosure, ScreenContainer, ScrollArea, SecretMaskingField, SecretTextField, Select, Snackbar, Stepper, Switch, TextField, ToggleButton, Tooltip, Typography, VerticalSpace, areOptionsOfTypeCollection, birthMaxDate, birthMinDate, formatDateFromString, lastDigitMaskingFormatting };
